/**
 * Librarys
 */
import React, { useEffect, useState } from "react";
import useToggleVisibility from "../hooks/useToggleVisibility";
import useFieldValidation  from "../hooks/useFieldValidation";
import Swal from "sweetalert2"
import macLogo from "../styles/img/logo.png";

/**
 * Estilos
 */
import "../styles/reservar.css"
import "../styles/table.css"

/**
 * Componentes
 */
import Footer from "../components/footer";
import Header from "../components/header";

/**
 * Objetos
 */
import { createMedicoMail, createMedicoCRM } from "../objects/medico";
import { createEventIntent, createReserveMail } from "../objects/reserve";
import { StepCirugia, StepMedico, StepPaciente, StepClinica, StepExtras } from "../components/steps";
import MacSpinner from "../components/MacSpinner";

/**
 * Utilerías
 */
import {cie} from '../utils/cie';
import { procedimientos } from "../utils/procedimiento";
import { MODO_DEMO, UNIDAD_DEMO } from "../utils/demo";
import { compararInformación } from "../utils/functions";


/**
 * Folio de la solicitud: QX-AAAAMMDD-XXXXXX
 * Fecha local de la solicitud + 6 caracteres aleatorios sin letras/números
 * confusos (sin 0/O, 1/I/L). Se guarda en la descripción del evento como
 * "|Folio=..." (al final, para no mover los segmentos que se leen por posición).
 */
/** Suma un día a una fecha "AAAA-MM-DD" respetando fin de mes/año (devuelve "AAAA-MM-DD" con ceros). */
const sumarUnDia = (fechaISO) => {
    const [a, m, d] = String(fechaISO).split('-').map(Number)
    const f = new Date(a, m - 1, d + 1)
    return f.getFullYear() + '-' + String(f.getMonth() + 1).padStart(2, '0') + '-' + String(f.getDate()).padStart(2, '0')
}

const ALFABETO_FOLIO = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'
const generarFolio = () => {
    const d = new Date()
    const fecha = d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0')
    const bytes = new Uint8Array(6)
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes)
    else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
    const sufijo = Array.from(bytes, (b) => ALFABETO_FOLIO[b % ALFABETO_FOLIO.length]).join('')
    return `QX-${fecha}-${sufijo}`
}

/**
 * Page asignada a la solicitud de reservación de quirófano para cirugía
 * @returns Component Devuelve el sitio con los elementos y funcionalidad asignada
 */
const ReservarCirugia = () => {

    const [buildHadError,setBuildHadError] = useState(false)
    const [buildingList, setBuildingList] = useState([])
    const [buildingSelected ,setBuildingSelected] = useState("-- Seleccione la unidad hospitalaria --")
    const [cantidadEventos,setCantidadEventos] = useState(0)
    const [cedula, setCedula] = useState("")
    const [cedulaHadError, setCedulaHadError] = useState(false)
    const [cieList] = useState(cie)
    const [clicBuildingSelect,setClicBuildingSelect] = useState(false)
    const [clicHoraFinalSelected, setClicHoraFinalSelected] = useState(false)
    const [clicHoraInicialSelected, setClicHoraInicialSelected] = useState(false)
    const [clicResourcesSelect,setResourcesClicSelect] = useState(false)
    const [diagnostico, setDiagnostico] = useState("")
    const [diagnosticoSeleccionado, setDiagnosticoSeleccionado] = useState("")
    const [edad, setEdad] = useState("")
    const [equipoQuirirgico, setEquipoQuirurgico] = useState("")
    const [equipoQuirirgicoHadError, setEquipoQuirirgicoHadError] = useState(false)
    const [eventosTotales, setEventosTotales] = useState([])
    const [estudios, setEstudios] = useState("")
    const [extras, setExtras] = useState("")
    const [fechaNacimientoHadError,setFechaNacimientoHadError] = useState(true)
    const [fecha_nacimiento,setFechaNacimiento] = useState("")
    const [fecha_seleccionada,setFechaSeleccionada] = useState("")
    const [fechaSeleccionadaHadError,setFechaSeleccionadaHadError] = useState("")
    const [hadExtras,setHadExtras] = useState(false)
    const [hadEstudios,setHadEstudios] = useState(false)
    const [horaFinalHadError, setHoraFinalHadError] = useState(false)
    const [horaFinalSelected,setHoraFinalSelected] = useState("-- Seleccione la hora final --")
    const [duracionSeleccionada, setDuracionSeleccionada] = useState(null)
    const [horaInicialHadError,setHoraInicialHadError] = useState(false)
    const [horaInicialSelected,setHoraInicialSelected] = useState("-- Seleccione la hora inicial --")
    const [horasFinalArray, setHorasFinalArray] = useState([])
    const [horasFinalesDisponibles, setHorasFinalesDisponibles] = useState([])
    const [horasInicialArray, setHorasIniciaArray] = useState([])
    const [horasInicialesDisponibles,setHorasInicialesDisponibles] = useState([])
    const [horasReservadas, setHorasReservadas] = useState([])
    const [ladoProcedimiento,setLadoProcedimiento] = useState("No se cuenta con la información")
    const [isOtroLadoProcedimiento, setIsOtroLadoProcedimiento] = useState(false)
    const [ladoProcedimientoHadError, setLadoProcedimientoHadError] = useState(false)
    const [isMostrarBusqueda,setIsMostrarBusqueda] = useState(true)
    const [isMostrarBusquedaProcedimiento,setIsMostrarBusquedaProcedimiento] = useState(true)
    const [isMostrarBusquedaMedico,setIsMostrarBusquedaMedico] = useState(true)
    const [isToolTipDiagnosticoVisble, setIsToolTipDiagnosticoVisible] = useState(false)
    const [isToolTipProcedimientoVisble, setIsToolTipProcedimientoVisible] = useState(false)
    const [isToolTipTipoClienteVisible, setIsToolTipTipoClienteVisible] = useState(false)
    const [isToolTipVisible, setIsToolTipVisible] = useState(false)
    const [medicoList, setMedicoList] = useState([])
    const [messageError,setMessageError] = useState("")
    const [nombreAnestesiologo, setNombreAnestesiologo] = useState("")
    const [tipoAnestesiologo, setTipoAnestesiologo] = useState("")
    const [nombreAnestesiologoHadError, setNombreAnestesiologoHadError] = useState(false)
    const [isAnestesiologoExterno, setIsAnestesiologoExterno] = useState(false)
    const [nombrePaciente, setNombrePaciente] = useState("")
    const [nombrePaciennteHadError, setNombrePacienteHadError] = useState(false)
    const [procedimiento, setProcedimiento] = useState("")
    const [procedimientoSeleccionado, setProcedimientoSeleccionado] = useState("")
    const [,  setMedicoSeleccionado] = useState("")
    const [,  setAnestesiologoMedicoSeleccionado] = useState("")
    const [procedimientoHadError, setProcedimientoHadError] = useState(false)
    const [resourceHadError,setResourceHadError] = useState(false)
    const [resourcesList, setResourcesList] = useState([])
    const [resourcesSelected ,setResourcesSelected] = useState("-- Seleccione el quirófano deseado --")
    const [resultList,setResultList] = useState([])
    const [resultProcedimientoList,setResultProcedimientoList] = useState([])
    const [resultMedicoList,setResultMedicoList] = useState([])
    const [resultAnestesiologoList,setResultAnestesiologoList] = useState([])
    const [seMuestra,setSeMuestra] = useState(true)
    const [seMuestraProdecimiento,setSeMuestraProcedimiento] = useState(true)
    const [seMuestraMedico,setSeMuestraMedico] = useState(true)
    const [seMuestraMedicoAnestesiologo,setSeMuestraMedicoAnestesiologo] = useState(true)
    const [sexo,setSexo] = useState("")
    const [telefono, setTelefono] = useState("")
    const [telefonoHadError, setTelefonoHadError] = useState(false)
    const [telefonoPaciente, setTelefonoPaciente] = useState("No se cuenta con la información")
    const [telefonoPacienteHadError, setTelefonoPacienteHadError] = useState(false)
    // ¿Es paciente hospitalizado? — checkbox simple en el Paso 3 (Paciente)
    const [pacienteHospitalizado, setPacienteHospitalizado] = useState(false)
    const onCheckPacienteHospitalizado = () => setPacienteHospitalizado(!pacienteHospitalizado)
    const [tipoAnestesia, setTipoAnestesia] = useState("No se cuenta con la información")
    const [tipoCliente, setTipoCliente] = useState("")
    const [,  setTipoClienteMensaje] = useState("Por favor indique el tipo de convenio que tiene el cliente")
    const [tipoClienteHadError, setTipoClienteHadError] = useState(false)
    const [opcionCliente, setOpcionCliente] = useState("")
    const [today,setToday] = useState("")
    const [yesterday, setYesterday] = useState("")
    const [uhList, setUhList] = useState([])

    const [, setHospitalSeleccionado] = useState("")
    const [isMediaHora, setIsMediaHora] = useState(false)
    const [mostrarMensajeFecha,setMostrarMensajeFecha] = useState(true)

    const [equipoEspecial, setEquipoEspecial] = useState("")
    const [proveedorEquipoEspecial, setProveedorEquipoEspecial] = useState("")
    const [equipoEspecialProveedorText,setEquipoEspecialProveedorText] = useState("")
    const [equipoEspecialProveedorList,setEquipoEspecialProveedorList] = useState([])
    const [equipoEspecialHadError, setEquipoEspecialHadError] = useState(false)

    const [hemoderivados, setHemoderivados] = useState("")
    const [hemoderivadosHadError, setHemoderivadosHadError] = useState(false)

    const [calidadContactList, setCalidadContactList] = useState([])
    const [reservacionContactList, setReservacionContactList] = useState([])
    const [imagenContactList, setImagenContactList] = useState([])
    const [hemoContactList, setHemoContactList] = useState([])
    const [comprasContactList, setComprasContactList] = useState([])

    const [proveedorMaterial, setProveedorMaterial] = useState("")
    const [materialProveedorText,setMaterialProveedorText] = useState("")
    const [materialProveedorList,setMaterialProveedorList] = useState([])


    // Creamos un estado para manejar si el checkbox está marcado o no
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedFechaNoSeCuenta, setIsCheckedFechaNoSeCuenta] = useState(false);

  const [nuevoMedico,setNuevoMedico] = useState({})
  const [isNuevoMedico,setIsNuevoMedico] = useState(false)

  // Estado que bloquea el botón Reservar mientras se procesa el envío
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Estados del spinner de carga
  const [spinnerVisible,  setSpinnerVisible]  = useState(false)
  const [spinnerMessage,  setSpinnerMessage]  = useState("Cargando...")


  // Función que maneja el cambio del estado del checkbox

useEffect(()=>{
    setIsChecked(false)
    setIsToolTipVisible(false)
    setIsOtroLadoProcedimiento(false)
    setEstudios("")
},[])

  const handleCheckboxChangeFechaNacimiento = (event) => {
    // Usamos event.target.checked para obtener el valor de marcado/desmarcado
    setIsCheckedFechaNoSeCuenta(event.target.checked);
  };

  useEffect(()=>{
    if(isChecked){
        setTelefonoPaciente("No se cuenta con la información")
    }
  },[isChecked])

  useEffect(()=>{
    if(isCheckedFechaNoSeCuenta){
        setEdad("No se cuenta con la información")
    }
  },[isCheckedFechaNoSeCuenta])
    
    useEffect(()=>{
        /**
         * Se obtiene la fecha actual y se predefine en la selección de fechas con formato yyyy-mm-dd
         */
        let hoy = new Date()
        let dia = ""
        if(hoy.getDate().toString().length < 2){
            dia = "0" + hoy.getDate()
        }
        else{
            dia = hoy.getDate()
        }
        let mes = hoy.getMonth() + 1
        if(mes.toString().length < 2){
            mes = "0" + mes
        }
        let nextMont = hoy.getMonth() + 2
        if(nextMont.toString().length < 2){
            nextMont = "0" + nextMont
        }
        setToday(hoy.getFullYear() + "-" + mes + "-" + dia)
        setMostrarMensajeFecha(true)

        let fechaAnterior = sumarDias(hoy, -1)
        let diaAnterior = ""
        if(fechaAnterior.getDate().toString().length < 2){
            diaAnterior = "0" + fechaAnterior.getDate()
        }
        else{
            diaAnterior = fechaAnterior.getDate()
        }
        let mesAnterior = fechaAnterior.getMonth() + 1
        if(mesAnterior.toString().length < 2){
            mesAnterior = "0" + mesAnterior
        }
        setYesterday(fechaAnterior.getFullYear() + "-" + mesAnterior + "-" + diaAnterior)

        /**
         * Se obtiene la lista de unidades hospitalarias
         */
        

        /**
        * Se obtiene la lista de médicos disponibles
        */
        setSpinnerVisible(true)
        setSpinnerMessage("Cargando catálogos...")

        const fetchMedicos = fetch('https://agendaqx-getmedicos-data-1082492640140.us-south1.run.app/')
            .then(response => response.json())
            .then(data => setMedicoList(data))
            .catch(() => setMedicoList([]))

        /**
        * Se obtiene la lista de unidades de servicios disponibles
        */
        const fetchUH = fetch('https://agendaqx-getunidadeshospitalarias-1082492640140.us-south1.run.app')
            .then(response => response.json())
            .then(data => { data.sort(compararInformación('hospital')); setUhList(data) })
            .catch(() => setUhList([]))

        /**
        * Se obtiene la lista de unidades de quirófanos disponibles.
        * La reservación pública SIEMPRE lista solo las 11 unidades productivas,
        * sin importar el ambiente. El ambiente solo decide la URL del servicio:
        * se usa la de pruebas únicamente si REACT_APP_ENV es "test" o "development"
        * (si la variable no llega al despliegue, se asume producción).
        */
        const AMBIENTE = (process.env.REACT_APP_ENV || 'production').toLowerCase().trim()
        // En ambiente demo (utils/demo.js) el catálogo de unidades se toma del servicio de pruebas
        const IS_TEST = MODO_DEMO || AMBIENTE === 'test' || AMBIENTE === 'development'

        const urlBuilding = IS_TEST
            ? 'https://agendaqx-getbuildingtest-1082492640140.us-south1.run.app'
            : 'https://agendaqx-getbuildingprod-1082492640140.us-south1.run.app'

        // Normaliza para comparar: acentos en una sola forma, espacios no
        // separables / dobles como uno solo y sin espacios al inicio o final.
        const normalizarUnidad = (t) => String(t || '')
            .normalize('NFC')
            .replace(/[\u00a0\u2007\u202f]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase()

        // Unidades productivas habilitadas para agendar (se filtra por Building_Id)
        const UNIDADES_PRODUCTIVAS = [
            'Hospital-MAC-Mexicali',
            'Hospital-MAC-Santa Fe',
            'Hospital-MAC-Perisur',
            'Hospital-MAC-Guadalajara',
            'Hospital-MAC-Ecatepec',
            'Hospital-MAC-Interlomas',
            'Hospital-MAC-La Viga',
            'Hospital-MAC-León',
            'Hospital-MAC-Tijuana',
            'Hospital-HMAS-Los Cabos',
            'Hospital-MAC-Celaya',
            'Hospital-MAC-Tampico',
        ]
        // Ambiente demo (utils/demo.js): solo Integración Procesos Clínicos
        const UNIDADES_VALIDAS = new Set((MODO_DEMO ? [UNIDAD_DEMO] : UNIDADES_PRODUCTIVAS).map(normalizarUnidad))

        const fetchBuilding = fetch(urlBuilding)
            .then(response => response.json())
            .then(data => {
                const lista = Array.isArray(data) ? data : []
                const resultado = lista.filter(u => UNIDADES_VALIDAS.has(normalizarUnidad(u.Building_Id)))
                setBuildingList(resultado)
            })
            .catch(() => setBuildingList([]))

        // Ocultar spinner cuando los 3 catálogos hayan terminado
        Promise.all([fetchMedicos, fetchUH, fetchBuilding])
            .finally(() => setSpinnerVisible(false))

        
    },[])

    function sumarDias(fecha, dias){
        fecha.setDate(fecha.getDate() + dias);
        return fecha;
      }


    useEffect(()=>{
        if(buildingSelected !== "-- Seleccione la unidad hospitalaria --"){//Se verifica que se haya seleccionado una unidad hospitalaria
            if(buildHadError){//Si se habia indicado error en unidad hospitalaria se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setBuildHadError(false)

            if("Hospital-MAC-Celaya" === buildingSelected){
                setIsMediaHora(true)
            }
            else{
                setIsMediaHora(true)
            }
            /**
             * Se obtiene la lista de quirófanos disponibles en la unidad hospitalaria seleccionada
             */

            let requestObject = {
                Building_Id : buildingSelected
            }

            
            for(let i=0; i < buildingList.length; i++){
                if(buildingList[i].Building_Id === buildingSelected){
                    setCalidadContactList(Array.isArray(buildingList[i].calidad_contact) ? buildingList[i].calidad_contact : [])
                    setReservacionContactList(Array.isArray(buildingList[i].reservacion_contact) ? buildingList[i].reservacion_contact : [])
                    setImagenContactList(Array.isArray(buildingList[i].imagen_contact) ? buildingList[i].imagen_contact : [])
                    setHemoContactList(Array.isArray(buildingList[i].hemoderivados_contact) ? buildingList[i].hemoderivados_contact : [])
                    setComprasContactList(Array.isArray(buildingList[i].compras_contact) ? buildingList[i].compras_contact : [])


                    i = buildingList.length
                }
            }

            const requestOptions = {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestObject)
            };

            fetch('https://agendaqx-getsalas-1082492640140.us-south1.run.app', requestOptions)
                .then(response => response.json())
                .then(data => {
                    data.sort(compararInformación('Resource_Name'))
                    setResourcesList(data)
                    setResourcesSelected("-- Seleccione el quirófano deseado --")
                    setSpinnerVisible(false)
                })
                .catch(error => {
                    setResourcesList([])
                    setSpinnerVisible(false)
                });
            setSpinnerVisible(true)
            setSpinnerMessage("Cargando quirófanos disponibles...")

            for(let i=0;i<uhList.length;i++){
                if(uhList[i].calendar === buildingSelected){
                    setHospitalSeleccionado(uhList[i].hospital)
                }
            }
        }
        else{//Se limpia la lista de quirofanos
            setResourcesList([])
            setIsMediaHora(false)
        }
    },[buildingSelected,buildHadError,uhList,buildingList])

    useEffect(()=>{
        if(cedula !== ""){
            if(cedulaHadError){//Si se habia indicado error en cedula profesional se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setCedulaHadError(false)
        }
    },[cedula,cedulaHadError])

    useEffect(()=>{
        let busqueda = []
        if(diagnostico){
            setSeMuestra(true)
            if(diagnostico.length >= 3){
                cieList.forEach(
                    cie => {
                        if(quitarAcentos(cie.NOMBRE.toUpperCase()).includes(quitarAcentos(diagnostico.toUpperCase()))){
                            busqueda.push(cie)
                        }
                    }
                )
                if(busqueda.length > 0){
                    if(isMostrarBusqueda){
                    }
                    else{
                    }
                }
                else{
                    setIsMostrarBusqueda(true)
                }
                setResultList(busqueda)
            }
            else{
                setResultList([])
                setIsMostrarBusqueda(true)
            }
        }
        else{
            setResultList([])
            setIsMostrarBusqueda(true)
            setSeMuestra(false)
        }

    },[diagnostico,cieList,isMostrarBusqueda])

    useEffect(()=>{
        let busqueda = []
        if(procedimiento){
            setSeMuestraProcedimiento(true)
            if(procedimiento.length >= 3){
                procedimientos.forEach(
                    cie => {
                        if(quitarAcentos(cie.PRO_NOMBRE.toUpperCase()).includes(quitarAcentos(procedimiento.toUpperCase()))){
                            busqueda.push(cie)
                        }
                    }
                )
                if(busqueda.length > 0){
                    if(isMostrarBusquedaProcedimiento){
                    }
                    else{
                    }
                }
                else{
                    setIsMostrarBusquedaProcedimiento(true)
                }
                setResultProcedimientoList(busqueda)
            }
            else{
                setResultProcedimientoList([])
                setIsMostrarBusquedaProcedimiento(true)
            }
        }
        else{
            setResultProcedimientoList([])
            setIsMostrarBusquedaProcedimiento(true)
            setSeMuestraProcedimiento(false)
        }
    },[procedimiento,isMostrarBusquedaProcedimiento])

    useEffect(()=>{
        if(equipoQuirirgico !== ""){
            if(equipoQuirirgicoHadError){//Si se habia indicado error en el equipo quirúrgico se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setEquipoQuirirgicoHadError(false)
        }
    },[equipoQuirirgico,equipoQuirirgicoHadError])

    useEffect(()=>{
        if(equipoEspecial !== ""){
            if(equipoEspecialHadError){//Si se habia indicado error en el equipo quirúrgico se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setEquipoEspecialHadError(false)
        }
    },[equipoEspecial,equipoEspecialHadError])

    useEffect(()=>{
        if(hemoderivados !== ""){
            if(hemoderivadosHadError){//Si se habia indicado error en el equipo quirúrgico se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setHemoderivadosHadError(false)
        }
    },[hemoderivados,hemoderivadosHadError])

    useEffect(()=>{
        let horasOcupadas = []
        eventosTotales.forEach(
                    event => {
                        let fechaReservar = fecha_seleccionada.split("-")
                        let fechaEvento = ""
                        let dayEvento = new Date()
                        let dayInicial =  new Date()
                        if(event.start){
                            if(event.start.dateTime){
                                fechaEvento = event.start.dateTime.split("T")
                                dayEvento = new Date(fechaEvento[0].split("-")[1]+"/"+fechaEvento[0].split("-")[2]+"/"+fechaEvento[0].split("-")[0])
                            }else{
                                fechaEvento = event.start.split("T")
                                dayEvento = new Date(fechaEvento[0].split("-")[1]+"/"+fechaEvento[0].split("-")[2]+"/"+fechaEvento[0].split("-")[0])
                            }
                        }
                        else{
                            
                        }
                        

                        dayInicial =  new Date(fechaReservar[1]+"/"+fechaReservar[2]+"/"+fechaReservar[0])
                        

                        if(dayEvento.getFullYear() + "-" + dayEvento.getMonth() + "-" + dayEvento.getDate() === dayInicial.getFullYear() + "-" + dayInicial.getMonth() + "-" + dayInicial.getDate()){
                            let tiempoInicial = ""
                            if(event.start.dateTime){
                                tiempoInicial = event.start.dateTime.toString().split('T')
                            }
                            else{
                                tiempoInicial = event.start.toString().split('T')
                            }
                            let horaInicial = parseInt(tiempoInicial[1].split(':')[0])

                            let tiempoFinal = ""
                            if(event.end.dateTime){
                                tiempoFinal = event.end.dateTime.toString().split('T')
                            }
                            else{
                                tiempoFinal = event.end.toString().split('T')
                            }

                            let horaFinal = parseInt(tiempoFinal[1].split(':')[0])
                            let minutoFinal = parseInt(tiempoFinal[1].split(':')[1])
                            let description = event.description.toString().split('|')
                            let AppointmentType = ""
                            let Unidad = ""
                            if(description.length > 1){
                                AppointmentType = description[0].split('=')[1]
                                Unidad = description[8].split('=')[1]
                            }
                            else{
                                AppointmentType = description[0]
                            }

                            let horaReservadaObject = {
                                'Recurso' : AppointmentType,
                                'Hora' : horaInicial,
                                'Identificador':"Inicio",
                                'Unidad' : Unidad
                            }

                            horasOcupadas.push(horaReservadaObject)
                            for(let i=horaInicial + 1;i<horaFinal;i++){
                                let horaReservadaObject = {
                                    'Recurso' : AppointmentType,
                                    'Hora' : i,
                                    'Identificador':"Intermedio",
                                    'Unidad' : Unidad
                                }
                                horasOcupadas.push(horaReservadaObject)
                            }
                            if(minutoFinal === 30){
                                let horaReservadaObject = {
                                    'Recurso' : AppointmentType,
                                    'Hora' : horaFinal,
                                    'Identificador':"Final",
                                    'Unidad' : Unidad
                                }
                                horasOcupadas.push(horaReservadaObject)
                            }
                        }
                    }
                )
        setHorasReservadas(horasOcupadas)
    },[eventosTotales,fecha_seleccionada])

    useEffect(()=>{
        if(fecha_nacimiento){
            setEdad(getEdad(fecha_nacimiento))
        }
        else{
            if(fechaNacimientoHadError){
                setMessageError("")
            }
            if(isCheckedFechaNoSeCuenta){
                setFechaNacimientoHadError(false)
            }
            else{
                setFechaNacimientoHadError(true)
            }
            
        }
        function getEdad(dateString) {
            let hoy = new Date()
            let fechaNacimiento = new Date(dateString)
            let edad = hoy.getFullYear() - fechaNacimiento.getFullYear()
            let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth()
            let diferenciaDias = hoy.getDate() - fechaNacimiento.getDate()
            let diasAgregar = 0
            switch(fechaNacimiento.getMonth()){
                case 0:
                    diasAgregar = 31
                    break
                case 1:
                    diasAgregar = 28
                    break
                case 2:
                    diasAgregar = 31
                    break
                case 3:
                    diasAgregar = 30
                    break
                case 4:
                    diasAgregar = 31
                    break
                case 5:
                    diasAgregar = 30
                    break
                case 6:
                    diasAgregar = 31
                    break
                case 7:
                    diasAgregar = 31
                    break
                case 8:
                    diasAgregar = 30
                    break
                case 9:
                    diasAgregar = 31
                    break
                case 10:
                    diasAgregar = 30
                    break
                case 11:
                    diasAgregar = 31
                    break
                default:
                    diasAgregar = 0
                    break
            }
            if (
              diferenciaMeses < 0 ||
              (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
            ) {
              edad--
              diferenciaMeses = diferenciaMeses + 12
            }

            if (
                diferenciaDias < 0 ||
                (diferenciaDias === 0 && hoy.getDate() < fechaNacimiento.getDate())
              ) {
                diferenciaMeses--
                diferenciaDias = diferenciaDias + diasAgregar
              }
              if(edad >= 0){
                setMessageError("")
                setFechaNacimientoHadError(false)
                return edad + "a " + diferenciaMeses + "m " + diferenciaDias +"d"
              }
              else{
                if(fechaNacimientoHadError){
                    setMessageError("")
                }

                setFechaNacimientoHadError(true)
                return ""
              }
          }
    },[fecha_nacimiento,fechaNacimientoHadError,isCheckedFechaNoSeCuenta])

    useEffect(()=>{
        // Al cambiar la fecha, se limpian hora y duración porque las horas
        // disponibles se recalculan según las reservas existentes ese día
        setHoraFinalSelected("-- Seleccione la hora final --")
        setHoraInicialSelected("-- Seleccione la hora inicial --")
        setDuracionSeleccionada(null)

    },[fecha_seleccionada])

    useEffect(()=>{
        if(fecha_seleccionada){
            getEdad(fecha_seleccionada)
        }
        else{
            setFechaSeleccionadaHadError(true)
        }

        function getEdad(dateString) {
            let hoy = new Date()
            hoy = sumarDias(hoy,-1)
            let fecha = dateString.split('-')
            if(parseInt(fecha[0]) < hoy.getFullYear()){
                setFechaSeleccionadaHadError(true)
            }
            else{
                if(parseInt(fecha[1]) < (hoy.getMonth() + 1)){
                    if(parseInt(fecha[0]) > hoy.getFullYear()){
                        setFechaSeleccionadaHadError(false)
                    }
                    else{
                        setFechaSeleccionadaHadError(true)
                    }
                }
                else{
                    if(parseInt(fecha[2]) < (hoy.getDate())){
                        if(parseInt(fecha[1]) === (hoy.getMonth() + 1)){
                            setFechaSeleccionadaHadError(true)
                        }
                        else{
                            setFechaSeleccionadaHadError(false)
                        }
                    }
                    else{
                        setFechaSeleccionadaHadError(false)
                    }
                }
            }
          }
    },[fecha_seleccionada,fechaSeleccionadaHadError])

    useEffect(()=>{
        if(!fecha_seleccionada){//Se verifica si la fecha se encuentra vacía
            if(today){//Se verifica si se cuenta con el valor de la fecha actual
                //Se predefine la fecha actual como fecha seleccionada
                setMostrarMensajeFecha(true)
            }
        }

        //Se solicitan las horas iniciales disponibles
        getTimeLeft()
        /**
         * Función que obtiene las horas disponibles para el inicio de la cirugía
         */
        function getTimeLeft(){
            //Se obtiene el día actual
            let hoy = new Date()

            let dia = ""
            if(hoy.getDate().toString().length < 2){
                dia = "0" + hoy.getDate()
            }
            else{
                dia = hoy.getDate()
            }
            let mes = hoy.getMonth() + 1
            if(mes.toString().length < 2){
                mes = "0" + mes
            }

            fetch('https://agendaqx-geteventos-1082492640140.us-south1.run.app')
            .then(response => response.json())
            .then(data => {
                let resultados = []
                for(let i=0;i<data.length;i++){
                    // Las cirugías canceladas no ocupan el horario (se puede volver a agendar)
                    if(data[i].event && !['cancelada','cancelado','cancelled','canceled','cancel'].includes(String(data[i].event.summary || data[i].event.status || '').trim().toLowerCase())){
                        resultados.push(data[i].event)
                    }
                }


                resultados.sort(function(x, y) {
                var firstDate = new Date(x.start.dateTime),
                    SecondDate = new Date(y.start.dateTime);
                    
                if (firstDate < SecondDate) return -1;
                if (firstDate > SecondDate) return 1;
                return 0;
                });

                if(resultados.length !== cantidadEventos){
                    setHoraFinalSelected("-- Seleccione la hora final --")
                    setHoraInicialSelected("-- Seleccione la hora inicial --")
                }

                setCantidadEventos(resultados.length)
                setEventosTotales(resultados)
            })
            .catch(error => {
                setCantidadEventos(0)
                setEventosTotales([])
            });


            let horasArray = []
            if(fecha_seleccionada === hoy.getFullYear() + "-" + mes + "-" + dia){//Se  verifica si el día seleccionado corresponde al día actual
                //Se obtiene la hora actual
                let ahora = new Date()
                let hora = ahora.getHours()
                horasArray = []

                for(let i=hora + 1;i<24;i++){//Se agregan las horas que aun están disponibles en el día actual considerando tambien medias horas
                    horasArray.push({
                        hora : i,
                        minutos: "00"
                    })
                    if(isMediaHora){
                        horasArray.push({
                            hora : i,
                            minutos: "30"
                        })
                    }
                }
            }
            else{//Se ha seleccionado otra fecha por lo que se muestran las 24 horas disponibles considerando medias horas
                if(isMediaHora){
                    horasArray = [
                        {
                            hora : "00",
                            minutos: "00"
                        },
                        {
                            hora : "00",
                            minutos: "30"
                        },
                        {
                            hora : "01",
                            minutos: "00"
                        },
                        {
                            hora : "01",
                            minutos: "30"
                        },
                        {
                            hora : "02",
                            minutos: "00"
                        },
                        {
                            hora : "02",
                            minutos: "30"
                        },
                        {
                            hora : "03",
                            minutos: "00"
                        },
                        {
                            hora : "03",
                            minutos: "30"
                        },
                        {
                            hora : "04",
                            minutos: "00"
                        },
                        {
                            hora : "04",
                            minutos: "30"
                        },
                        {
                            hora : "05",
                            minutos: "00"
                        },
                        {
                            hora : "05",
                            minutos: "30"
                        },
                        {
                            hora : "06",
                            minutos: "00"
                        },
                        {
                            hora : "06",
                            minutos: "30"
                        },
                        {
                            hora : "07",
                            minutos: "00"
                        },
                        {
                            hora : "07",
                            minutos: "30"
                        },
                        {
                            hora : "08",
                            minutos: "00"
                        },
                        {
                            hora : "08",
                            minutos: "30"
                        },
                        {
                            hora : "09",
                            minutos: "00"
                        },
                        {
                            hora : "09",
                            minutos: "30"
                        },
                        {
                            hora : "10",
                            minutos: "00"
                        },
                        {
                            hora : "10",
                            minutos: "30"
                        },
                        {
                            hora : "11",
                            minutos: "00"
                        },
                        {
                            hora : "11",
                            minutos: "30"
                        },
                        {
                            hora : "12",
                            minutos: "00"
                        },
                        {
                            hora : "12",
                            minutos: "30"
                        },
                        {
                            hora : "13",
                            minutos: "00"
                        },
                        {
                            hora : "13",
                            minutos: "30"
                        },
                        {
                            hora : "14",
                            minutos: "00"
                        },
                        {
                            hora : "14",
                            minutos: "30"
                        },
                        {
                            hora : "15",
                            minutos: "00"
                        },
                        {
                            hora : "15",
                            minutos: "30"
                        },
                        {
                            hora : "16",
                            minutos: "00"
                        },
                        {
                            hora : "16",
                            minutos: "30"
                        },
                        {
                            hora : "17",
                            minutos: "00"
                        },
                        {
                            hora : "17",
                            minutos: "30"
                        },
                        {
                            hora : "18",
                            minutos: "00"
                        },
                        {
                            hora : "18",
                            minutos: "30"
                        },
                        {
                            hora : "19",
                            minutos: "00"
                        },
                        {
                            hora : "19",
                            minutos: "30"
                        },
                        {
                            hora : "20",
                            minutos: "00"
                        },
                        {
                            hora : "20",
                            minutos: "30"
                        },
                        {
                            hora : "21",
                            minutos: "00"
                        },
                        {
                            hora : "21",
                            minutos: "30"
                        },
                        {
                            hora : "22",
                            minutos: "00"
                        },
                        {
                            hora : "22",
                            minutos: "30"
                        },
                        {
                            hora : "23",
                            minutos: "00"
                        },
                        {
                            hora : "23",
                            minutos: "30"
                        },
                    ]
                }
                else{
                    horasArray = [
                        {
                            hora : "00",
                            minutos: "00"
                        },
                        {
                            hora : "01",
                            minutos: "00"
                        },
                        {
                            hora : "02",
                            minutos: "00"
                        },
                        {
                            hora : "03",
                            minutos: "00"
                        },
                        {
                            hora : "04",
                            minutos: "00"
                        },
                        {
                            hora : "05",
                            minutos: "00"
                        },
                        {
                            hora : "06",
                            minutos: "00"
                        },
                        {
                            hora : "07",
                            minutos: "00"
                        },
                        {
                            hora : "08",
                            minutos: "00"
                        },
                        {
                            hora : "09",
                            minutos: "00"
                        },
                        {
                            hora : "10",
                            minutos: "00"
                        },
                        {
                            hora : "11",
                            minutos: "00"
                        },
                        {
                            hora : "12",
                            minutos: "00"
                        },
                        {
                            hora : "13",
                            minutos: "00"
                        },
                        {
                            hora : "14",
                            minutos: "00"
                        },
                        {
                            hora : "15",
                            minutos: "00"
                        },
                        {
                            hora : "16",
                            minutos: "00"
                        },
                        {
                            hora : "17",
                            minutos: "00"
                        },
                        {
                            hora : "18",
                            minutos: "00"
                        },
                        {
                            hora : "19",
                            minutos: "00"
                        },
                        {
                            hora : "20",
                            minutos: "00"
                        },
                        {
                            hora : "21",
                            minutos: "00"
                        },
                        {
                            hora : "22",
                            minutos: "00"
                        },
                        {
                            hora : "23",
                            minutos: "00"
                        }
                    ]
                }
            }
            
            //Se asignan las horas iniciales disponibles
            setHorasIniciaArray(horasArray)
            //Se solicitan las horas finales disponibles
        }
    },[fecha_seleccionada,today,buildingSelected,resourcesSelected,horaInicialSelected,cantidadEventos,isMediaHora])

    useEffect(()=>{
        //Se solicitan las horas de finalización disponibles
        getFinalTimeLeft()
        /**
         * Función que obtiene las horas disponibles para finalización de la cirugía
         */
        function getFinalTimeLeft(){
            //Se obtiene la hora inicial seleccionada
            let hora = horaInicialSelected.toString().split(':')[0]
            let horasArray = []
            let contador = 0

            for(let i=parseInt(hora) + 1;i<24;i++){//Se agregan las horas disponibles en el día seleccionado considerando también medias horas
                let hora = i
                if(hora.toString().length < 2){
                    hora = "0" + hora
                }
                horasArray.push({
                    hora : hora,
                    minutos: "00"
                })

                if(isMediaHora){
                    horasArray.push({
                        hora : hora,
                        minutos: "30"
                    })
                }
                
                contador = contador + 1
            }

            //Se obtienen la cantidad de horas faltantes para completar esquema de 24 horas
            let faltantes = 24 - contador

            for(let i=0;i < faltantes - 1;i++){//Se agregan las horas faltantes considerando también medias horas (las horas agregadas corresponde al día siguiente del seleccionado)
                let hora = i
                if(hora.toString().length < 2){
                    hora = "0" + hora
                }
                horasArray.push({
                    hora : hora,
                    minutos: "00"
                })
                if(isMediaHora){
                    horasArray.push({
                        hora : hora,
                        minutos: "30"
                    })
                }
            }
            //Se asignan las horas finales disponibles
            setHorasFinalArray(horasArray)
        }
    },[horaInicialSelected,isMediaHora])

    useEffect(()=>{
        let horasValidas = []
        if(horasReservadas.length > 0){
            for(let i=0;i<horasFinalArray.length;i++){
                let encontrado = false
                for(let j=0;j<horasReservadas.length;j++){
                    if(parseInt(horasFinalArray[i].hora) === parseInt(horasReservadas[j].Hora) && horasReservadas[j].Recurso === resourcesSelected && horasReservadas[j].Unidad === buildingSelected){
                        if(horasReservadas[j].Identificador !== "Inicio"){
                            encontrado = true
                        }
                        else{
                            if(parseInt(horasReservadas[j].Hora) > parseInt(horaInicialSelected.split(':')[0])){
                                horasValidas.push(horasFinalArray[i])
                                i = horasFinalArray.length
                            }
                        }
                        j = horasReservadas.length
                    }
                }
                if(!encontrado && horasFinalArray[i]){
                    horasValidas.push(horasFinalArray[i])
                }
            }
            setHorasFinalesDisponibles(horasValidas)
        }
        else{
            setHorasFinalesDisponibles(horasFinalArray)
        }
    },[horasReservadas,horasFinalArray,resourcesSelected,horaInicialSelected,buildingSelected])

    useEffect(()=>{
        let horasValidas = []
        if(horasReservadas.length > 0){
            for(let i=0;i<horasInicialArray.length;i++){
                let encontrado = false
                for(let j=0;j<horasReservadas.length;j++){
                    if(parseInt(horasInicialArray[i].hora) === parseInt(horasReservadas[j].Hora) && horasReservadas[j].Recurso === resourcesSelected && horasReservadas[j].Unidad === buildingSelected){
                        
                        encontrado = true
                        if(horasReservadas[j].Identificador === 'Final' && horasInicialArray[i].minutos === '30'){
                            //encontrado = false
                        }
                    }
                }

                
                if(!encontrado){
                    horasValidas.push(horasInicialArray[i])
                }
            }


            setHorasInicialesDisponibles(horasValidas)
        }
        else{
            setHorasInicialesDisponibles(horasInicialArray)
        }
    },[horasReservadas,horasInicialArray,resourcesSelected,buildingSelected,fecha_seleccionada])

    useToggleVisibility(isToolTipDiagnosticoVisble,  "diagnosticoToolTip")
    useToggleVisibility(isToolTipProcedimientoVisble, "procedimientoToolTip")
    useToggleVisibility(isToolTipTipoClienteVisible,  "tipoClienteToolTip")
    useToggleVisibility(isToolTipVisible,             "telefonoToolTip")
    
    useFieldValidation(nombrePaciente,      v => validarNombre(v),              nombrePaciennteHadError,    setNombrePacienteHadError,    setMessageError)
    useFieldValidation(procedimiento,       v => v !== "",                      procedimientoHadError,      setProcedimientoHadError,     setMessageError)
    useFieldValidation(ladoProcedimiento,   v => v !== "",                      ladoProcedimientoHadError,  setLadoProcedimientoHadError, setMessageError)
    useFieldValidation(tipoCliente,         v => v !== "" && opcionCliente !== "", tipoClienteHadError,    setTipoClienteHadError,       setMessageError, [opcionCliente])
    useFieldValidation(nombreAnestesiologo, v => v !== "" && tipoAnestesiologo !== "", nombreAnestesiologoHadError, setNombreAnestesiologoHadError, setMessageError, [tipoAnestesiologo])

    useEffect(()=>{
        if(buildingSelected !== "-- Seleccione la unidad hospitalaria --"){//Si se cuenta con una unidad hospitalaria seleccionada se despliega la lista de quirófanos
            setResourcesClicSelect(true)
        }
    },[resourcesList,buildingSelected])

    useEffect(()=>{
        setHoraInicialSelected("-- Seleccione la hora inicial --")
        setHoraFinalSelected("-- Seleccione la hora final --")
    },[resourcesSelected])

    useEffect(()=>{
        if(resourcesSelected !== "-- Seleccione el quirófano deseado --"){//Se verifica si se ha seleccionado un quirófano valido
            if(resourceHadError){//Si se habia indicado error en quirófano se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setResourceHadError(false)
        }
    },[resourcesSelected,resourceHadError])

    useEffect(()=>{
        if(tipoAnestesiologo){
            if(tipoAnestesiologo === "Staff"){
                setIsAnestesiologoExterno(false)
                setNombreAnestesiologo("Anestesiólogo Staff")
            }
            else{
                if(tipoAnestesiologo === "No se cuenta con la información"){
                    setIsAnestesiologoExterno(false)
                    setNombreAnestesiologo("No se cuenta con la información")
                }
                else{
                    setIsAnestesiologoExterno(true)
                    setNombreAnestesiologo("")
                }
            }
        }
        else{
            setIsAnestesiologoExterno(false)
        }
    },[tipoAnestesiologo])

    useEffect(()=>{
        let expresion = /^\d{10}$/gm
        if(expresion.test(telefono)){
            if(telefonoHadError){//Si se habia indicado error en teléfono de contacto del medico se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setTelefonoHadError(false)
        }
    },[telefono,telefonoHadError])

    const expresion = /^\d{10}$/gm
    useEffect(()=>{
        if((expresion.test(telefonoPaciente) || isChecked) && telefonoPaciente !== telefono){
            if(telefonoPacienteHadError){//Si se habia indicado error en teléfono de contacto del paciente se limpia el mensaje de ayuda y el respectivo indicador
                setMessageError("")
            }
            setTelefonoPacienteHadError(false)
        }
    },[telefonoPaciente,telefonoPacienteHadError,telefono,isChecked])

    /**
     * Función que permite el registro de un evento
     */
    const getReserve = async (nombre) =>{
        try{
            // Folio generado ANTES de enviar para que quede guardado en el evento
            const folio = generarFolio()
            /**
             * Se da formato a los parametros correspondientes a las fechas (actual,inical y final)
             */
            let date = new Date()
            let today = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
            let result = resourcesList.find( resource => resource.Resource_Name === resourcesSelected && resource.Building_Id === buildingSelected)
            let horaInicialSeparada = horaInicialSelected.toString().split(':')
            let horaFinalSeparada = horaFinalSelected.toString().split(':')
            let fechaFinal = fecha_seleccionada + "T" + horaFinalSelected

            if(parseInt(horaFinalSeparada[0]) < parseInt(horaInicialSeparada[0])){//En caso de que la hora final sea menor que la inicial se agrega un día para indicar que se trata del día siguiente
                // Antes se armaba como "2026-10-3T01:00" (día sin cero y sin cambio de mes),
                // fecha inválida que la Agenda descarta y por eso la cirugía no se veía.
                fechaFinal = sumarUnDia(fecha_seleccionada) + "T" + horaFinalSelected

            }

            // Sanitizar todos los campos de usuario antes de enviar a las APIs
            const sNombre             = sanitize(nombre)
            const sNombrePaciente     = sanitize(nombrePaciente)
            const sProcedimiento      = sanitize(procedimientoSeleccionado)
            const sEquipoQuirurgico   = sanitize(equipoQuirirgico)
            const sExtras             = sanitize(extras)
            const sTelefono           = sanitize(telefono)

            //Solicitud de registro de un evento
            let solicitudBody = "AppointmentType=" + result.Resource_Name
            solicitudBody += "|Medico=" + sNombre
            solicitudBody += "|Paciente=" + sNombrePaciente
            solicitudBody += "|Procedimiento=" + sProcedimiento
            solicitudBody += "|Equipo Quirúrgico=" + sEquipoQuirurgico
            if(hadExtras){
                if(extras){
                    solicitudBody += "|Extras=" + sExtras
                }
                else{
                    solicitudBody += "|Extras=NA"
                }
            }
            else{
                solicitudBody += "|Extras=NA"
            }
            solicitudBody += "|Telefono Medico=" + telefono
            solicitudBody += "|Telefono Paciente=" + telefonoPaciente
            solicitudBody += "|Unidad Hospitalaroa=" + buildingSelected
            solicitudBody += "|PacienteHospitalizado=" + (pacienteHospitalizado ? "Si" : "No")
            // Campo propio e independiente de "Material especial": checkbox
            // "¿Requiere de algún Material o Equipo especial?" de la sección
            // Clínica. Se manda aparte para que se muestre con su propia
            // etiqueta en los detalles de la cirugía, sin mezclarse con el
            // arreglo materialEspecial.
            if (hadMaterialEquipoEspecial && materialEquipoEspecial && materialEquipoEspecial.trim() !== "") {
                solicitudBody += "|RequerimientoEspecial=" + materialEquipoEspecial.trim()
            }

            let duracion = parseInt(horaFinalSeparada[0]) - parseInt(horaInicialSeparada[0])
            if(duracion < 0){
                duracion = duracion + 24
            }
            solicitudBody += "|Duracion=" + duracion
            if(ladoProcedimiento){
                if(isOtroLadoProcedimiento){
                    solicitudBody += "|LadoProcedimiento=Otro(" + ladoProcedimiento + ")"
                }
                else{
                    solicitudBody += "|LadoProcedimiento=" + ladoProcedimiento
                }
                
            }
            else{
                solicitudBody += "|LadoProcedimiento=NA"
            }
            if(nombreAnestesiologo){
                solicitudBody += "|Anestesiologo=" + nombreAnestesiologo
            }
            else{
                solicitudBody += "|Anestesiologo=NA"
            }
            if(tipoAnestesia){
                solicitudBody += "|TipoAnestesia=" + tipoAnestesia
            }
            else{
                solicitudBody += "|TipoAnestesia=NA"
            }
            if(fecha_nacimiento){
                if(isCheckedFechaNoSeCuenta){
                    solicitudBody += "|FechaNacimientoPaciente=No se cuenta con la información"
                }
                else{
                    solicitudBody += "|FechaNacimientoPaciente=" + fecha_nacimiento
                }
                
            }
            else{
                solicitudBody += "|FechaNacimientoPaciente=NA"
            }
            if(edad){
                solicitudBody += "|EdadPaciente=" + edad
            }
            else{
                solicitudBody += "|EdadPaciente=NA"
            }
            if(sexo){
                solicitudBody += "|SexoPaciente=" + sexo
            }
            else{
                solicitudBody += "|SexoPaciente=NA"
            }
            if(tipoCliente){
                solicitudBody += "|TipoCliente=" + tipoCliente
            }
            else{
                solicitudBody += "|TipoCliente=NA"
            }
            if(diagnosticoSeleccionado){
                solicitudBody += "|Diagnostico=" + diagnosticoSeleccionado
            }
            else{
                solicitudBody += "|Diagnostico=NA"
            }
            solicitudBody += "|Solicitado=" + nombre
            if(fecha_seleccionada === yesterday){
                solicitudBody += "|Concepto=Sin Programar"
            }
            else{
                solicitudBody += "|Concepto=Solicitud"
            }
            if(estudios){
                solicitudBody += "|EstudiosTransoperatorios=" + estudios
            }
            else{
                solicitudBody += "|EstudiosTransoperatorios=NA"
            }
            if(opcionCliente){
                solicitudBody += "|TipoClienteOpcion=" + opcionCliente
            }
            else{
                solicitudBody += "|TipoClienteOpcion=NA"
            }
            if(tipoAnestesiologo){
                solicitudBody += "|TipoAnestesiologo=" + tipoAnestesiologo
            }
            else{
                solicitudBody += "|TipoAnestesiologo=NA"
            }

            if(!equipoEspecial){
                solicitudBody += "|EquipoEspecial=No se requiere"
            }
            else{
                solicitudBody += "|EquipoEspecial=" + equipoEspecial
            }
            

            if(!hemoderivados){
                solicitudBody += "|Hemoderivados=No se requiere"
            }
            else{
                solicitudBody += "|Hemoderivados=" + hemoderivados
            }

            let imagenologiaObject = {
                rayoxX : isRayosX,
                arcoC : isArcoC
            }

            let sendImagen = false
            let textoImagen = ""

            if(imagenologiaObject.rayoxX || imagenologiaObject.arcoC){
                sendImagen = true
                textoImagen = "Servicios de imagen: "
                if(imagenologiaObject.rayoxX){
                    textoImagen = textoImagen + "Rayos X "
                }
                if(imagenologiaObject.arcoC){
                    textoImagen = textoImagen + "Arco en C "
                }
            }

            let materialEspecialArray = materialProveedorList

            let rentaEquiposArray = equipoEspecialProveedorList

            let sendCompras = false
            let textoMateriales = ""
            let texttoEquipos = ""

            if(materialProveedorList.length > 0 || equipoEspecialProveedorList.length > 0 || (hadMaterialEquipoEspecial && materialEquipoEspecial.trim() !== "")){
                sendCompras = true
                if(materialProveedorList.length > 0){
                    textoMateriales = "Materiales Especiales requeridos: "
                    textoMateriales = textoMateriales + materialProveedorText
                }

                if(hadMaterialEquipoEspecial && materialEquipoEspecial.trim() !== ""){
                    textoMateriales = textoMateriales + (textoMateriales ? " | " : "Materiales/Equipo especial requerido: ") + materialEquipoEspecial.trim()
                }

                if(equipoEspecialProveedorList.length > 0){
                    texttoEquipos = "Equipos Especiales requeridos: "
                    texttoEquipos = texttoEquipos + equipoEspecialProveedorText
                }
            }

            let muestrapatologicaObject = {
                trasOperatorios : isEstudiosTransoperatorios,
                postOperatorios : isEstudiosPostoperatorios
            }

            let sendHemo = false
            let textoHemo = ""

            if(muestrapatologicaObject.postOperatorios || muestrapatologicaObject.trasOperatorios){
                sendHemo = true

                textoHemo = "Muestra patológica requerida: "
                if(muestrapatologicaObject.postOperatorios){
                    textoHemo = textoHemo + "PostOperatorios "
                }
                if(muestrapatologicaObject.trasOperatorios){
                    textoHemo = textoHemo + "TransOperatorios "
                }

            }
    

            if(telefono && (telefonoPaciente || telefonoPaciente === "No se cuenta con la información")){
                if(telefono.length === 10 && (telefonoPaciente.length === 10 || telefonoPaciente === "No se cuenta con la información")){
                    solicitarEvento()
                }
                else{

                    solicitarEvento()
                }
                
            }
            else{
                solicitarEvento()
            }
            

            /**
             * Función asyncrona que solicita el registro de un evento
             */
            async function solicitarEvento(){
                // Folio al final de la descripción (no se muestra en la Agenda; solo seguimiento)
                if (!solicitudBody.includes('|Folio=')) solicitudBody += "|Folio=" + folio
                const response = await createEventIntent(
                    solicitudBody,
                    fecha_seleccionada + "T" + horaInicialSelected,
                    "Site",
                    today,
                    result.Building_Id,
                    result.Resource_Id,
                    result.Resource_Name,
                    fechaFinal,
                    imagenologiaObject,
                    materialEspecialArray,
                    rentaEquiposArray,
                    muestrapatologicaObject
                )

                /* ── Notificaciones por correo DESACTIVADAS (ya no se envían correos) ──
                   Se conserva el código por si se reactivan; para hacerlo, quitar este comentario
                   y la línea "void [...]" de abajo.

                for(let i=0; i < (reservacionContactList || []).length; i++){
                    if(reservacionContactList[i] && reservacionContactList[i].active){
                        createReserveMail(reservacionContactList[i].email,
                            buildingSelected,
                            fecha_seleccionada + " " + horaInicialSelected,
                            sNombre,
                            sProcedimiento,
                            sTelefono,
                            sNombrePaciente,
                            textoImagen,
                            textoMateriales,
                            texttoEquipos,
                            textoHemo
                        )
                    }
                }

                if(sendCompras){
                    for(let i=0; i < (comprasContactList || []).length; i++){
                        if(comprasContactList[i] && comprasContactList[i].active){
                            createReserveMail(comprasContactList[i].email,
                                buildingSelected,
                                fecha_seleccionada + " " + horaInicialSelected,
                                sNombre,
                                sProcedimiento,
                                sTelefono,
                                sNombrePaciente,
                                textoImagen,
                                textoMateriales,
                                texttoEquipos,
                                textoHemo
                            )
                        }
                    }
                }

                if(sendHemo){
                    for(let i=0; i < (hemoContactList || []).length; i++){
                        if(hemoContactList[i] && hemoContactList[i].active){
                            createReserveMail(hemoContactList[i].email,
                                buildingSelected,
                                fecha_seleccionada + " " + horaInicialSelected,
                                sNombre,
                                sProcedimiento,
                                sTelefono,
                                sNombrePaciente,
                                textoImagen,
                                textoMateriales,
                                texttoEquipos,
                                textoHemo
                            )
                        }
                    }
                }

                if(sendImagen){
                    for(let i=0; i < (imagenContactList || []).length; i++){
                        if(imagenContactList[i] && imagenContactList[i].active){
                            createReserveMail(imagenContactList[i].email,
                                buildingSelected,
                                fecha_seleccionada + " " + horaInicialSelected,
                                sNombre,
                                sProcedimiento,
                                sTelefono,
                                sNombrePaciente,
                                textoImagen,
                                textoMateriales,
                                texttoEquipos,
                                textoHemo
                            )
                        }
                    }
                }

                if(isNuevoMedico){
                    for(let i=0; i < (calidadContactList || []).length; i++){
                        if(calidadContactList[i] && calidadContactList[i].active){
                            createMedicoMail(nuevoMedico.nombres,nuevoMedico.hospital,calidadContactList[i].email,"",telefono,"",nuevoMedico.today,nuevoMedico.especialidad)
                        }
                    }
                }
                ── fin de notificaciones por correo ── */
                // Evita avisos de variables sin uso mientras los correos estén desactivados
                void [createReserveMail, createMedicoMail, sendCompras, sendHemo, sendImagen, isNuevoMedico, nuevoMedico, textoImagen, textoMateriales, texttoEquipos, textoHemo, sNombre, sProcedimiento, sTelefono, sNombrePaciente]

                if(response === "success"){//Registro de evento exitoso
                    // El folio es el mismo que se guardó en el evento (ver generarFolio)
                    const fechaFormato = fecha_seleccionada.split('-').reverse().join('/')
                    Swal.fire({
                        html: `
                            <div style="text-align:center;padding:8px 0 4px">
                                <div style="background:linear-gradient(135deg,#14988f,#0d6e67);border-radius:50%;width:64px;height:64px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                </div>
                                <p style="font-size:18px;font-weight:700;color:#1a202c;margin:0 0 4px">¡Solicitud enviada!</p>
                                <p style="font-size:13px;color:#4a5568;margin:0 0 20px">Se le notificará cuando sea confirmada por el equipo de quirófanos</p>
                                <div style="background:#f7fafc;border:1px solid #e2e8f0;border-radius:10px;padding:14px 16px;text-align:left;font-size:13px;color:#4a5568">
                                    <div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid #e2e8f0"><span>Folio</span><strong style="color:#14988f;font-size:14px">${folio}</strong></div>
                                    <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #e2e8f0"><span>Hospital</span><strong style="color:#1a202c">${buildingSelected}</strong></div>
                                    <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #e2e8f0"><span>Quirófano</span><strong style="color:#1a202c">${resourcesSelected}</strong></div>
                                    <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #e2e8f0"><span>Fecha</span><strong style="color:#1a202c">${fechaFormato}</strong></div>
                                    <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #e2e8f0"><span>Horario</span><strong style="color:#1a202c">${horaInicialSelected} – ${horaFinalSelected}</strong></div>
                                    <div style="display:flex;justify-content:space-between;padding:6px 0"><span>Paciente</span><strong style="color:#1a202c">${nombrePaciente}</strong></div>
                                </div>
                                <p style="font-size:11px;color:#718096;margin:12px 0 0">Guarda el folio <strong>${folio}</strong> como referencia de tu solicitud</p>
                            </div>`,
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#14988f",
                        customClass: { popup: 'swal-reservacion-exitosa' },
                      }).then((result) => {
                        if (result.isConfirmed) {
                            setCedula("")
                            setTelefono("")
                            setNombrePaciente("")
                            setTelefonoPaciente("")
                            setFechaNacimiento("")
                            setEdad("")
                            setTipoCliente("")
                            setDiagnostico("")
                            setDiagnosticoSeleccionado("")
                            setProcedimiento("")
                            setProcedimientoSeleccionado("")
                            setLadoProcedimiento("")
                            setNombreAnestesiologo("")
                            setTipoAnestesia("")
                            setEquipoQuirurgico("")
                            setHadExtras(false)
                            setExtras("")
                            setIsNuevoMedico(false)
                            setNuevoMedico({})
                            window.location.reload()
                        }
                    })
                }
                else{//Error en el registro de un evento
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response,
                      })
                }
            }
            
        }
        catch(error){//Error inesperado
            Swal.fire({
                title: "Error",
                text: error.message,
                icon: "error",
                button: "Aceptar",
            });
        }
    }

    /**
     * Función que atrapa el evento de limpiar la búsqueda
     * @returns Devuelve el estado del objeto
     */
     const handleCancelarClick = () => (event) => {
        event.preventDefault()
        setDiagnostico("")
        setDiagnosticoSeleccionado("")
    }

    const handleCancelarProcedimientoClick = () => (event) => {
        event.preventDefault()
        setProcedimiento("")
        setProcedimientoSeleccionado("")
    }

    const handleCancelarMedicoClick = () => (event) => {
        event.preventDefault()
        setCedula("")
        setMedicoSeleccionado("")
    }

    const handleCancelarMedicoAnestesiologoClick = () => (event) => {
        event.preventDefault()
        setNombreAnestesiologo("")
        setAnestesiologoMedicoSeleccionado("")
    }

    const handleAgregarMedicoClick = () => (event) => {
        event.preventDefault()
        
        if(buildingSelected !== "-- Seleccione la unidad hospitalaria --"){
            
            for(let i=0;i<buildingList.length;i++){
                if(buildingList[i].Building_Id === buildingSelected){
                    let hospital = buildingList[i].HOSPITAL

                    Swal.fire({
                        customClass:'modalRegistro',
                        html:`<div class="form_wrapper">
                            <div class="form_container">
                                <div class="row clearfix">
                                    <div class="">
                                        <form autocomplete="off" method="post">
                                            <h2 class="modalTitle">Nuevo Médico</h2>
                                            <br />
                                            <div class="input_field">
                                                <input type="text" name="inputAP" id="inputAP" placeholder="Ingrese el apellido paterno del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputAM" id="inputAM" placeholder="Ingrese el apellido materno del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputNombre" id="inputNombre" placeholder="Ingrese el nombre del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputEspecialidad" id="inputEspecialidad" placeholder="Ingrese la especialidad del médico" 
                                                required class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[' ']/g,'')"/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>`,
                        showDenyButton: true,
                        denyButtonText: "Cancelar",
                        denyButtonColor: "grey",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#04afaa",
                        scrollbarPadding:false,
                        allowOutsideClick:false,
                        width:'500px',
                        heightAuto: false,
                        focusConfirm: false,
                        showCloseButton:true,
                        preConfirm: () => {
                            if (document.getElementById('inputNombre').value) {
                                if (document.getElementById('inputAP').value) {
                                    if (document.getElementById('inputAM').value) {
                                        if (document.getElementById('inputEspecialidad').value) {
                                            let date = new Date()
                                            let today = date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2,"0") + "-" + date.getDate().toString().padStart(2,"0") + " " + date.getHours().toString().padStart(2,"0") + ":" + date.getMinutes().toString().padStart(2,"0") + ":" + date.getSeconds().toString().padStart(2,"0")
                                            let nombres = document.getElementById('inputAP').value + " " + document.getElementById('inputAM').value + " " + document.getElementById('inputNombre').value
                                            let especialidad = document.getElementById('inputEspecialidad').value

                                            let doctorInfo = {
                                                Nombre : nombres.toUpperCase(),
                                                Especialidad : especialidad.toUpperCase(),
                                                Unidad_CRM : buildingList[i].CRM,
                                                Hospital : buildingList[i].HOSPITAL,
                                                Active : true,
                                                DTCreate : today,
                                                Validate : 2
                                            }

                                            solicitarNuevoMedico()

                                            async function solicitarNuevoMedico(){
                                                const response = await createMedicoCRM(doctorInfo)

                                                if(response === "success"){//Registro de médico exitoso
                                                    Swal.fire({
                                                        icon: 'warning',
                                                        title: 'Nuevo Médico',
                                                        text: 'Se ha registrado nuevo médico',
                                                        confirmButtonText: "Aceptar",
                                                        confirmButtonColor: "#04afaa",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            fetch('https://agendaqx-getmedicos-data-1082492640140.us-south1.run.app/')
                                                            .then(response => response.json())
                                                            .then(data => {
                                                                setMedicoList(data)
                                                                setNuevoMedico({
                                                                    'nombres' : nombres,
                                                                    'hospital' : hospital,
                                                                    'today' : today,
                                                                    'especialidad' : especialidad.toUpperCase()
                                                                })
                                                                setIsNuevoMedico(true)
                                                                setCedula(doctorInfo.Nombre)
                                                            })
                                                            .catch(error => setMedicoList([]));
                                                            
                                                        }
                                                    })
                                                }
                                                else{//Error en el registro de un médico
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'Error',
                                                        text: response,
                                                    })
                                                }
                                            }

                                        } else {
                                            Swal.showValidationMessage('Proporcione la especialidad del médico')   
                                        }
                                    } else {
                                        Swal.showValidationMessage('Proporcione el apellido materno del médico')   
                                    }
                                } else {
                                    Swal.showValidationMessage('Proporcione el apellido paterno del médico')   
                                }
                            } else {
                                Swal.showValidationMessage('Proporcione el nombre del médico')   
                            }
                        }
                    })
                }
            }
            
        }
        
    }

    const handleAgregarAnestesiologoClick = () => (event) => {
        event.preventDefault()
        
        if(buildingSelected !== "-- Seleccione la unidad hospitalaria --"){
            
            for(let i=0;i<buildingList.length;i++){
                if(buildingList[i].Building_Id === buildingSelected){
                    let hospital = buildingList[i].HOSPITAL

                    Swal.fire({
                        customClass:'modalRegistro',
                        html:`<div class="form_wrapper">
                            <div class="form_container">
                                <div class="row clearfix">
                                    <div class="">
                                        <form autocomplete="off" method="post">
                                            <h2 class="modalTitle">Nuevo Médico</h2>
                                            <br />
                                            <div class="input_field">
                                                <input type="text" name="inputAP" id="inputAP" placeholder="Ingrese el apellido paterno del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputAM" id="inputAM" placeholder="Ingrese el apellido materno del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputNombre" id="inputNombre" placeholder="Ingrese el nombre del médico" 
                                                required  class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                            </div>
                                            <div class="input_field">
                                                <input type="text" name="inputEspecialidad" id="inputEspecialidad" placeholder="Ingrese la especialidad del médico" 
                                                required class="inputText" autocomplete="off"
                                                oninput="this.value=value.replace(/[' ']/g,'')"/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>`,
                        showDenyButton: true,
                        denyButtonText: "Cancelar",
                        denyButtonColor: "grey",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#04afaa",
                        scrollbarPadding:false,
                        allowOutsideClick:false,
                        width:'500px',
                        heightAuto: false,
                        focusConfirm: false,
                        showCloseButton:true,
                        preConfirm: () => {
                            if (document.getElementById('inputNombre').value) {
                                if (document.getElementById('inputAP').value) {
                                    if (document.getElementById('inputAM').value) {
                                        if (document.getElementById('inputEspecialidad').value) {
                                            let date = new Date()
                                            let today = date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2,"0") + "-" + date.getDate().toString().padStart(2,"0") + " " + date.getHours().toString().padStart(2,"0") + ":" + date.getMinutes().toString().padStart(2,"0") + ":" + date.getSeconds().toString().padStart(2,"0")
                                            let nombres = document.getElementById('inputAP').value + " " + document.getElementById('inputAM').value + " " + document.getElementById('inputNombre').value
                                            let especialidad = document.getElementById('inputEspecialidad').value

                                            let doctorInfo = {
                                                Nombre : nombres.toUpperCase(),
                                                Especialidad : especialidad.toUpperCase(),
                                                Unidad_CRM : buildingList[i].CRM,
                                                Hospital : buildingList[i].HOSPITAL,
                                                Active : true,
                                                DTCreate : today,
                                                Validate : 2
                                            }

                                            solicitarNuevoMedico()

                                            async function solicitarNuevoMedico(){
                                                const response = await createMedicoCRM(doctorInfo)

                                                if(response === "success"){//Registro de médico exitoso
                                                    Swal.fire({
                                                        icon: 'warning',
                                                        title: 'Nuevo Médico',
                                                        text: 'Se ha registrado nuevo médico',
                                                        confirmButtonText: "Aceptar",
                                                        confirmButtonColor: "#04afaa",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            fetch('https://agendaqx-getmedicos-data-1082492640140.us-south1.run.app/')
                                                            .then(response => response.json())
                                                            .then(data => {
                                                                setMedicoList(data)
                                                                for(let i=0; i < (calidadContactList || []).length; i++){
                                                                    if(calidadContactList[i] && calidadContactList[i].active){
                                                                        createMedicoMail(nombres,hospital,calidadContactList[i].email,"","","",today,especialidad.toUpperCase())
                                                                    }
                                                                }
                                                                setNombreAnestesiologo(doctorInfo.Nombre)
                                                            })
                                                            .catch(error => setMedicoList([]));
                                                            
                                                        }
                                                    })
                                                }
                                                else{//Error en el registro de un médico
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'Error',
                                                        text: response,
                                                    })
                                                }
                                            }

                                        } else {
                                            Swal.showValidationMessage('Proporcione la especialidad del médico')   
                                        }
                                    } else {
                                        Swal.showValidationMessage('Proporcione el apellido materno del médico')   
                                    }
                                } else {
                                    Swal.showValidationMessage('Proporcione el apellido paterno del médico')   
                                }
                            } else {
                                Swal.showValidationMessage('Proporcione el nombre del médico')   
                            }
                        }
                    })
                }
            }
            
        }
        
    }

    /**
     * Función que atrapa los parametros para la búsqueda de un diagnóstico médico
     * @param {String} value Recibe los parametros de búsqueda
     */
    const handleDiagnosticoChange = (value) => {
        //Se asigna el diagnositico a buscar
        setDiagnostico(value)
        setDiagnosticoSeleccionado(value)
        setIsMostrarBusqueda(true)
    };

    const handleProcedimientoChange = (value) => {
        //Se asigna el diagnositico a buscar
        setProcedimiento(value)
        setProcedimientoSeleccionado(value)
        setIsMostrarBusquedaProcedimiento(true)
    };

    const handleCedulaChange = (value) => {
        //Se asigna el diagnositico a buscar
        setCedula(value)
        setMedicoSeleccionado(value)
        setIsMostrarBusquedaMedico(true)
    };

    const handleAnestesiologoChange = (value) => {
        //Se asigna el diagnositico a buscar
        setNombreAnestesiologo(value)
        setAnestesiologoMedicoSeleccionado(value)
        setSeMuestraMedicoAnestesiologo(true)
    };

    useEffect(()=>{
    },[seMuestraMedicoAnestesiologo])

    const agregarMaterial = () => (event) => {
        event.preventDefault()
        let textoActual = materialProveedorText
        let listaActual = materialProveedorList
        if(textoActual){
            if(textoActual.length > 0){
                textoActual = textoActual + "\n"
            }
        }

        if(equipoQuirirgico){
            if(proveedorMaterial){
                textoActual = textoActual + equipoQuirirgico + " - " + proveedorMaterial
                listaActual.push({
                    MaterialNombre : equipoQuirirgico,
                    MaterialProveedor : proveedorMaterial
                })
            }
            else{
                textoActual = textoActual + equipoQuirirgico
                listaActual.push({
                    MaterialNombre : equipoQuirirgico
                })
            }
        }

        setMaterialProveedorList(listaActual)
        setMaterialProveedorText(textoActual)
        setEquipoQuirurgico("")
        setProveedorMaterial("")
    }

    const agregarEquipoEspecial = () => (event) => {
        event.preventDefault()
        let textoActual = equipoEspecialProveedorText
        let listaActual = equipoEspecialProveedorList
        if(textoActual){
            if(textoActual.length > 0){
                textoActual = textoActual + "\n"
            }
        }

        if(equipoEspecial){
            if(proveedorEquipoEspecial){
                textoActual = textoActual + equipoEspecial + " - " + proveedorEquipoEspecial
                listaActual.push({
                    EquipoEspecialNombre : equipoEspecial,
                    EquipoEspecialProveedor : proveedorEquipoEspecial
                })
            }
            else{
                textoActual = textoActual + equipoEspecial
                listaActual.push({
                    EquipoEspecialNombre : equipoEspecial
                })
            }
        }

        setEquipoEspecialProveedorList(listaActual)
        setEquipoEspecialProveedorText(textoActual)
        setEquipoEspecial("")
        setProveedorEquipoEspecial("")
    }

    /**
     * Función que atrapa el evento clic para solicitar el registro de un evento
     * @returns Devuelve el estado del objeto
     */
    const handleReservaClick = () => (event) => {
        event.preventDefault()
        if (isSubmitting) return   // evita doble envío
        if(buildingSelected !== "-- Seleccione la unidad hospitalaria --"){//Se verifica si se ha seleccionado una unidad hospitalaria valida
            setBuildHadError(false)
            if(resourcesSelected !== "-- Seleccione el quirófano deseado --"){//Se verifica si se ha seleccionado un quirófano valido
                setResourceHadError(false)
                if(fecha_seleccionada){//Se verifica si se ha seleccionado una fecha valida
                    if(horaInicialSelected !== "-- Seleccione la hora inicial --"){//Se verifica si se ha seleccionado una hora inicial valida
                        setHoraInicialHadError(false)
                        if(horaFinalSelected !== "-- Seleccione la hora final --"){//Se verifica si se ha seleccionado una hora final valida
                            setHoraFinalHadError(false)
                            if(cedula !== ""){
                                setCedulaHadError(false)
                                if(validarNombre(nombrePaciente)){
                                    setNombrePacienteHadError(false)
                                    if(procedimiento !== "" && procedimientoSeleccionado !== ""){
                                        setProcedimientoHadError(false)
                                        if(equipoQuirirgico !== "" || true){
                                            setEquipoQuirirgicoHadError(false)///^\d{10}$/gm
                                            let expresion = /^\d{10}$/gm
                                            if(expresion.test(telefono)){
                                                setTelefonoHadError(false)
                                                let expresionDos = /^\d{10}$/gm
                                                if(expresionDos.test(telefonoPaciente)|| true){
                                                    let isMedicoValido = false

                                                    if(cedula){
                                                        isMedicoValido = true
                                                    }

                                                    let nombre = ""
                                                    
                                                    if(edad && edad.trim() !== ""){
                                                        if(!fechaSeleccionadaHadError){
                                                            if(true){
                                                                setTelefonoPacienteHadError(false)
                                                                if(ladoProcedimiento !== ""){
                                                                    setLadoProcedimientoHadError(false)
                                                                    if(tipoCliente !== "" && opcionCliente !== ""){
                                                                        if(nombreAnestesiologo !== "" && tipoAnestesiologo !== ""){
                                                                            
                                                                            if(equipoEspecial !== "" || true){
                                                                                setEquipoEspecialHadError(false)
                                                                                if(hemoderivados !== "" || true){
                                                                                    setHemoderivadosHadError(false)
                                                                                    setMessageError("")
                                                                            if(isMedicoValido){
                                                                                //Se muestra dialogo de confirmación con los detalles de la reservación
                                                                                let fechaInicial = fecha_seleccionada.toString().split('-')
                                                                                    
                                                                                let horaInicialSeparada = horaInicialSelected.toString().split(':')
                                                                                let horaFinalSeparada = horaFinalSelected.toString().split(':')
                                                                                let fechaFinal = fecha_seleccionada + "T" + horaFinalSelected
                                                                                let mensaje = buildingSelected + " en " + resourcesSelected + " de " + horaInicialSelected + " a " + horaFinalSelected + " con fecha " + fechaInicial[2] + "-" + fechaInicial[1] + "-" + fechaInicial[0]
                                                                                mensaje += " para el paciente " + nombrePaciente
                    
                                                                                if(parseInt(horaFinalSeparada[0]) < parseInt(horaInicialSeparada[0])){//En caso de que la hora final sea menor que la inicial se agrega un día para indicar que se trata del día siguiente
                                                                                    fechaFinal = sumarUnDia(fecha_seleccionada).split('-').reverse().join('-')
                                                                                    mensaje = buildingSelected + " en " + resourcesSelected + " de " + horaInicialSelected + " del " + fechaInicial[2] + "-" + fechaInicial[1] + "-" + fechaInicial[0] + " a " + horaFinalSelected + " del " + fechaFinal
                                                                                    mensaje += " para el paciente " + nombrePaciente
                                                                                }
                                                                                
                                                                                Swal.fire({
                                                                                    title: "Se buscará disponibilidad de quirófano para: " + nombre,
                                                                                    text: mensaje,
                                                                                    showDenyButton: false,
                                                                                    showCancelButton: true,
                                                                                    confirmButtonColor: '#14988f',
                                                                                    confirmButtonText: 'Aceptar',
                                                                                    denyButtonText: `Cancelar`,
                                                                                    cancelButtonText:`Cancelar`,
                                                                                }).then((result) => {
                                                                                    if (result.isConfirmed) {
                                                                                        //Se solicita el registro del evento
                                                                                        if(nombreAnestesiologo === "Anestesiólogo Staff" || nombreAnestesiologo === "No se cuenta con la información" || nombreAnestesiologo){
                                                                                            setIsSubmitting(true)
                                                                                            setSpinnerVisible(true)
                                                                                            setSpinnerMessage("Procesando reservación...")
                                                                                            clearDraft()
                                                                                            getReserve(cedula).finally(() => {
                                                                                                setIsSubmitting(false)
                                                                                                setSpinnerVisible(false)
                                                                                            })
                                                                                        }
                                                                                        else{
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                            else{
                                                                            }
                                                                            
                                                                            }
                                                                            else{
                                                                                setHemoderivadosHadError(true)
                                                                                setMessageError("Favor de ingresar los requerimiento de sangre y/o hemoderivados requeridos")
                                                                            }
                                                                            }
                                                                            else{
                                                                                setEquipoEspecialHadError(true)
                                                                                setMessageError("Favor de ingresar la renta de equipos  requerido")
                                                                            }
                                                                        }
                                                                        else{
                                                                            setNombreAnestesiologoHadError(true)
                                                                            setMessageError("Favor de seleccionar e ingresar el tipo de anestesiologo")
                                                                        }
                                                                    }
                                                                    else{
                                                                        setTipoClienteHadError(true)
                                                                        setMessageError("Favor de seleccionar e ingresar el tipo de cliente")
                                                                    }
                                                                }
                                                                else{
                                                                    setLadoProcedimientoHadError(true)
                                                                    setMessageError("Favor de ingresar el lado del procedimiento")
                                                                }
                                                            }
                                                            else{
                                                                setTelefonoPacienteHadError(true)
                                                                setMessageError("Favor de ingresar el teléfono de contacto del paciente, está información se utilizará para contactar al paciente y realizar el pre-registro, con el objetivo de tener un ingreso ágil")
                                                            }
                                                        }
                                                        else{
                                                            setMessageError("Ha seleccionado una fecha invalida")
                                                        }
                                                    }
                                                    else{
                                                        setMessageError("Ingresa la edad del paciente")
                                                    }
                                                    
                                                }
                                                else{
                                                    setTelefonoPacienteHadError(true)
                                                    setMessageError("Favor de ingresar el teléfono de contacto del paciente, está información se utilizará para contactar al paciente y realizar el pre-registro, con el objetivo de tener un ingreso ágil")
                                                }
                                            }
                                            else{
                                                setTelefonoHadError(true)
                                                setMessageError("Favor de ingresar el teléfono de contacto del médico tratante")
                                            }
                                        }
                                        else{
                                            setEquipoQuirirgicoHadError(true)
                                            setMessageError("Favor de ingresar los materiales o medicamentos requeridos")
                                        }
                                    }
                                    else{
                                        setProcedimientoHadError(true)
                                        setMessageError("Favor de ingresar el procedimiento a realizar")
                                    }
                                }
                                else{
                                    setNombrePacienteHadError(true)
                                    setMessageError("Favor de ingresar el nombre del paciente valido")
                                }
                            }
                            else{
                                setCedulaHadError(true)
                                setMessageError("Favor de ingresar la cedula profesional del médico tratante")
                            }
                        }
                        else{//Se muestra el error de hora final requerida
                            setHoraFinalHadError(true)
                            setMessageError("Favor de seleccionar la hora final de la cirugía")
                        }
                    }
                    else{//Se muestra el error de hora inicial requerida
                        setHoraInicialHadError(true)
                        setMessageError("Favor de seleccionar la hora inicial de la cirugía")
                    }
                }
                else{//Se muestra el error de fecha requerida
                    setMessageError("Favor de seleccionar la fecha de la cirugía")
                }
            }
            else{//Se muestra el error de quirófano requerido
                setResourceHadError(true)
                setMessageError("Favor de seleccionar el Quirófano deseado")
            }
        }
        else{//Se muestra el error de unidad hospitalaria requerida
            setBuildHadError(true)
            setMessageError("Favor de seleccionar la Unidad Hospitalaria")
        }
    }

    /**
     * Función que cambio de estado la visualización de la lista de unidades hospitalarias (visible o invisible)
     */
    /** Alterna la visibilidad de cualquier lista desplegable */
    const toggleDropdown = (setter) => setter(prev => !prev)

    /**
     * Calcula la hora final sumando minutos de duración a la hora inicial.
     * Devuelve string "HH:MM" o null si faltan datos.
     */
    const calcHoraFinal = (horaInicial, duracionMin) => {
        if (!horaInicial || horaInicial.includes('Seleccione') || !duracionMin) return null
        const [h, m] = horaInicial.split(':').map(Number)
        const totalMin = h * 60 + m + duracionMin
        const hFinal = Math.floor(totalMin / 60) % 24
        const mFinal = totalMin % 60
        return (hFinal < 10 ? '0' + hFinal : '' + hFinal) + ':' + (mFinal === 0 ? '00' : '30')
    }

    // Recalcular hora final cada vez que cambia hora inicial o duración
    useEffect(() => {
        const nueva = calcHoraFinal(horaInicialSelected, duracionSeleccionada)
        if (nueva) {
            setHoraFinalSelected(nueva)
            setHoraFinalHadError(false)
        } else {
            setHoraFinalSelected("-- Seleccione la hora final --")
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [horaInicialSelected, duracionSeleccionada])

    /**
     * Función que atrapa cuando se pierde la selección en el campo diagnósitico y oculta el tooltip
     */
     const onBlurDiagnostico = () => {
        setIsToolTipDiagnosticoVisible(false)
    };

    const onBlurProcedimiento = () => {
        setIsToolTipProcedimientoVisible(false)
    };

    /**
     * Función que atrapa cuando se pierde la selección en el campo teléfono y oculta el tooltip
     */

    /**
     * Función que atrapa cuando se pierde la selección en el campo tipo de cliente y oculta el tooltip
     */
    const onBlurTipoCliente = () => {
        setIsToolTipTipoClienteVisible(false)
    };

    /**
     * Función que atrapa el ingreso de la cedula profesional
     * @param {Event} cedula Recibe el evento disparado en la intruducción de texto
     */
     const onChangeCedula = (cedula) => {
        setCedula(cedula.target.value.toString().toUpperCase())
    };

    /**
     * Función que atrapa la selección de la fecha de cirugía
     * @param {Event} date Recibe el evento disparado en la selección de fecha
     */
    const onChangeDate = (date) => {
        setMostrarMensajeFecha(false)
        setFechaSeleccionada(date.target.value)
    };

    /**
     * Función que atrapa la selección del diagnóstico del paciente
     * @param {Event} diagnostico Recibe el evento disparado en la selección del diagnóstico
     */
    const onChangeDiagnostico = (diagnostico) => {
        setDiagnostico(diagnostico.target.value)
    };

    /**
     * Función que atrapa el ingreso de la edad del paciente
     * @param {Event} edad Recibe el evento disparado en la intruducción de texto
     */
    const onChangeEdad = (edad) => {
        setEdad(edad.target.value)
    };

    /**
     * Función que atrapa el ingreso del equipo quirurgico necesario
     * @param {Event} equipo Recibe el evento disparado en la intruducción de texto
     */
     const onChangeEquipoQuirurgico = (equipo) => {
        setEquipoQuirurgico(equipo.target.value)
    };

    const onChangeEquipoEspecial = (equipo) => {
        setEquipoEspecial(equipo.target.value)
    };

    const onChangeProveedorEquipoEspecial = (equipo) => {
        setProveedorEquipoEspecial(equipo.target.value)
    };

    const onChangeProveedorMaterial = (equipo) => {
        setProveedorMaterial(equipo.target.value)
    };

    const onChangeHemoderivados = (equipo) => {
        setHemoderivados(equipo.target.value)
    };

    /**
     * Función que atrapa el ingreso de requerimientos extras
     * @param {Event} extras Recibe el evento disparado en la intruducción de texto
     */
     const onChangeExtras = (extras) => {
        setExtras(extras.target.value)
    };


    /**
     * Función que atrapa el ingreso del lado del procedimiento a realizar
     * @param {Event} ladoProcedimiento Recibe el evento disparado en la intruducción de texto
     */

    /**
     * Función que atrapa la selección de la fecha de cirugía
     * @param {Event} date Recibe el evento disparado en la selección de fecha
     */
     const onChangeNacimientoDate = (date) => {
        setFechaNacimiento(date.target.value)
    };

    /**
     * Función que atrapa el ingreso del nombre del anestesiólogo
     * @param {Event} nombre Recibe el evento disparado en la intruducción de texto
     */
     const onChangeNombreAnestesiologo = (nombre) => {
        setNombreAnestesiologo(nombre.target.value)
    };

    /**
     * Función que atrapa el ingreso del nombre del paciente
     * @param {Event} nombre Recibe el evento disparado en la intruducción de texto
     */
     const onChangeNombrePaciente = (cedula) => {
        setNombrePaciente(cedula.target.value)
    };

    /**
     * Función que atrapa el ingreso del procedimiento a realizar
     * @param {Event} procedimiento Recibe el evento disparado en la intruducción de texto
     */
     const onChangeProcedimiento = (procedimiento) => {
        setProcedimiento(procedimiento.target.value)
    };

    /**
     * Función que atrapa la selección de un genero
     * @param {Event} sexo Recibe el evento disparado en la selección
     */
     const onChangeSexo = (sexo) => {
        setSexo(sexo.target.value)
    };

    const onChangeTypeCliente = (sexo) => {
        setOpcionCliente(sexo.target.value)
    };

    const onChangeTipoAnestesiologo = (sexo) => {
        setTipoAnestesiologo(sexo.target.value)
    };

    //     if(sexo.target.value === "Otro"){
    //     else{
        

    useEffect(()=>{
        if(opcionCliente){
            if(opcionCliente === "Gobierno"){
                setTipoCliente("Gobierno")
                setTipoClienteMensaje("Tipo de cliente con convenio de Gobierno")
            }
            else{
                if(opcionCliente === "Privado"){
                    setTipoCliente("Privado")
                    setTipoClienteMensaje("Tipo de cliente Privado")
                }
                else{
                    if(opcionCliente === "Aseguradora"){
                        setTipoCliente("")
                        setTipoClienteMensaje("Tipo de cliente Aseguradora")
                    }
                    else{
                        if(opcionCliente === "Empresa"){
                            setTipoClienteMensaje("Por favor indique el tipo de convenio que tiene")
                            setTipoCliente("")
                        }
                        else{
                            if(opcionCliente === "Oficina"){
                                setTipoCliente("Oficina")
                                setTipoClienteMensaje("Tipo de cliente Oficina")
                            }
                        }
                    }
                }
            }
        }
        else{
            setTipoClienteMensaje("Por favor indique el tipo de convenio que tiene el cliente")
        }
    },[opcionCliente])

    /**
     * Función que atrapa el ingreso de la cedula profesional
     * @param {Event} telefono Recibe el evento disparado en la intruducción de texto
     */
     const onChangeTelefono = (telefono) => {
        setTelefono(telefono.target.value)
    };

    /**
     * Función que atrapa el ingreso de la cedula profesional
     * @param {Event} telefono Recibe el evento disparado en la intruducción de texto
     */

    /**
     * Función que atrapa el ingreso del tipo de anestesía
     * @param {Event} tipo Recibe el evento disparado en la intruducción de texto
     */

    /**
     * Función que atrapa el ingreso del tipo de cliente
     * @param {Event} tipo Recibe el evento disparado en la intruducción de texto
     */
     const onChangeTipoCliente = (tipo) => {
        setTipoCliente(tipo.target.value)
    };

    /**
     * Función que atrapa el chequeo de la opción de información extras
     */
    const onCheckExtras = () => {
        setHadExtras(!hadExtras)
    }

    const onCheckEstudios = () => {
        setHadEstudios(!hadEstudios)
    }

    const [hadRentaEquipos,setRentaEquipos] = useState(false)

    const onCheckRentaEquipos = () => {
        setRentaEquipos(!hadRentaEquipos)
    }

    const [hadEspecificaciones,setHadEspecificaciones] = useState(false)

    const onCheckEspecificaciones = () => {
        setHadEspecificaciones(!hadEspecificaciones)
    }

    // Campo simple: "¿Requiere de algún Material o Equipo especial?"
    // (checkbox + texto libre) — se agrega para la sección Clínica, tal
    // como se solicita en la reservación original. Independiente del
    // esquema previo de material/proveedor (StepExtras, sin usar).
    const [hadMaterialEquipoEspecial, setHadMaterialEquipoEspecial] = useState(false)
    const onCheckMaterialEquipoEspecial = () => {
        setHadMaterialEquipoEspecial(!hadMaterialEquipoEspecial)
    }
    const [materialEquipoEspecial, setMaterialEquipoEspecial] = useState("")
    const onChangeMaterialEquipoEspecial = (e) => {
        setMaterialEquipoEspecial(e.target.value)
    }

    const [isRayosX,setIsRayosX] = useState(false)

    const onCheckRayosX = () => {
        setIsNoRequiereImagen(false)
        setIsRayosX(!isRayosX)
    }

    const [isArcoC,setIsArcoC] = useState(false)

    const onCheckArcoC = () => {
        setIsNoRequiereImagen(false)
        setIsArcoC(!isArcoC)
    }

    const [isNoRequiereImagen,setIsNoRequiereImagen] = useState(false)

    const onCheckNorequiereImagen = () => {
        setIsArcoC(false)
        setIsRayosX(false)
        setIsNoRequiereImagen(!isNoRequiereImagen)
    }

    const [hadHemoderivados,setHadHemoderivados] = useState(false)

    const onCheckHemoderivados = () => {
        setHadHemoderivados(!hadHemoderivados)
    }

    const [isEstudiosTransoperatorios,setIsEstudiosTransoperatorios] = useState(false)

    const onCheckEstudiosTransoperatocios = () => {
        setIsEstudiosTransoperatorios(!isEstudiosTransoperatorios)
    }

    const [isEstudiosPostoperatorios,setIsEstudiosPostoperatorios] = useState(false)

    const onCheckEstudiosPostoperatocios = () => {
        setIsEstudiosPostoperatorios(!isEstudiosPostoperatorios)
    }

    const [isNoRequiereEstudios,setIsNoRequiereEstudios] = useState(false)

    const onCheckNorequiereEstudios = () => {
        setIsNoRequiereEstudios(!isNoRequiereEstudios)
    }

    useEffect(()=>{
        if(isNoRequiereEstudios){
            setIsEstudiosPostoperatorios(false)
            setIsEstudiosTransoperatorios(false)
            setHadEstudios(false)
        }
    },[isNoRequiereEstudios])

    useEffect(()=>{
        if(hadEstudios){
            setIsNoRequiereEstudios(false)
        }
    },[hadEstudios])

    /**
     * Función que atrapa cuando se tiene seleccionado el campo diagnóstico y muestra el tooltip
     */
     const onFocusDiagnostico = () => {
        setIsToolTipDiagnosticoVisible(true)
    };

    const onFocusProcedimiento = () => {
        setIsToolTipProcedimientoVisible(true)
    };

    /**
     * Función que atrapa cuando se tiene seleccionado el campo teléfono y muestra el tooltip
     */

    /**
     * Función que atrapa cuando se tiene seleccionado el campo tipo de cliente y se muestra el tooltip
     */
    const onFocusTipoCliente = () => {
        setIsToolTipTipoClienteVisible(true)
    };

    /**
     * Función que elimina de una cadena los acentos
     * @param {String} cadena Recibe la cadena de caracteres a evaluar
     * @returns String Devuelve la cadena sin acentos
     */
    // ── Límites de longitud por campo ──────────────────────────────
    const MAX = {
        nombre:        120,   // nombre de paciente / médico / anestesiólogo
        telefono:       10,   // solo dígitos
        edad:           20,
        tipoCliente:   100,   // nombre del convenio o aseguradora
        diagnostico:   200,   // búsqueda CIE-10
        procedimiento: 200,   // búsqueda CIE-9
        material:      150,   // nombre del material / equipo especial
        materialEquipoEspecial: 500, // texto libre del check "Material o Equipo especial"
        proveedor:     150,   // nombre del proveedor
        hemoderivados: 300,
        extras:        500,   // observaciones
    }

    /**
     * Escapa caracteres HTML en una cadena para prevenir XSS
     * antes de enviar datos a las APIs.
     * @param {string} str Cadena a sanitizar
     * @returns {string} Cadena con caracteres especiales escapados
     */
    const sanitize = (str) => {
        if (!str) return ''
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2F;')
    }

    const quitarAcentos = (cadena) =>{
        const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
        return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
    }

    /**
     * Función que atrapa la selección de la hora final de la cirugía
     * @param {String} hora Se recibe la hora seleccionada
     * @returns Devuelve el estado del objeto
     */
    const seleccionarHoraFinal = (hora) => (event) => {
        event.preventDefault()
        //Se limpiar la ayuda al usuario si se contaba con error de hora final requerida
        if(horaFinalHadError){
            setMessageError("")
        }
        setHoraFinalHadError(false)

        //Se asigna la hora final y se oculta la lista de horas finales disponibles
        setHoraFinalSelected(hora)
        toggleDropdown(setClicHoraFinalSelected)
    }

    /**
     * Función que atrapa la selección de la hora inicial de la cirugía
     * @param {String} hora Se recibe la hora seleccionada
     * @returns Devuelve el estado del objeto
     */
    const seleccionarHoraInicial = (hora) => (event) => {
        event.preventDefault()
        //Se limpiar la ayuda al usuario si se contaba con error de hora inicial requerida
        if(horaInicialHadError){
            setMessageError("")
        }
        setHoraInicialHadError(false)

        //Se asigna la hora inicial y se oculta la lista de horas iniciales disponibles
        setHoraInicialSelected(hora)
        toggleDropdown(setClicHoraInicialSelected)
        //Se limpia la duración al cambiar la hora inicial
        setDuracionSeleccionada(null)
        setHoraFinalSelected("-- Seleccione la hora final --")
    }

    /**
     * Función que verifica si el nombre proporcionado es valida
     * @param {String} nombre Recibe la cadena de caracteres con el nombre proporcionado
     * @returns Boolean Devuelve si la cadena es valida
     */
    const validarNombre = (nombre) => {
        if(nombre !== ""){
            if(nombre.toString().toUpperCase() !== "Pendiente".toUpperCase()
            && nombre.toString().toUpperCase() !== "En revisión".toUpperCase()
            && nombre.toString().toUpperCase() !== "En revision".toUpperCase()
            && nombre.toString().toUpperCase() !== "Sin información".toUpperCase()
            && nombre.toString().toUpperCase() !== "Sin informacion".toUpperCase()
            && nombre.toString().toUpperCase() !== "No aplica".toUpperCase()
            && nombre.toString().toUpperCase() !== "S/A".toUpperCase()
            && nombre.toString().toUpperCase() !== "Se desconoce".toUpperCase()
            && nombre.toString().toUpperCase() !== "Conocido".toUpperCase()
            && nombre.toString().toUpperCase() !== "Desconocido".toUpperCase()
            && nombre.toString().toUpperCase() !== "na".toUpperCase()){
                return true
            }
            else{
                return false
            }
        }
        else{
            return false
        }
    }

    const handleEliminarMaterialClick = (evento) => (event) => {
        event.preventDefault()

        let nuevoArrayList = []
        for(let i=0; i<materialProveedorList.length; i++){
            if(materialProveedorList[i].MaterialNombre === evento.MaterialNombre
                && materialProveedorList[i].MaterialProveedor === evento.MaterialProveedor
            ){
            }
            else{
                nuevoArrayList.push(materialProveedorList[i])
            }
        }

        setMaterialProveedorList(nuevoArrayList)
    }

    const handleEliminarEquipoClick = (evento) => (event) => {
        event.preventDefault()

        let nuevoArrayList = []
        for(let i=0; i<equipoEspecialProveedorList.length; i++){
            if(equipoEspecialProveedorList[i].EquipoEspecialNombre === evento.EquipoEspecialNombre
                && equipoEspecialProveedorList[i].EquipoEspecialProveedor === evento.EquipoEspecialProveedor
            ){
            }
            else{
                nuevoArrayList.push(equipoEspecialProveedorList[i])
            }
        }

        setEquipoEspecialProveedorList(nuevoArrayList)
    }

    useEffect(()=>{
        let busqueda = []
        if(cedula){
            setSeMuestraMedico(true)

            if(cedula.length >= 3){
                medicoList.forEach(
                    cie => {
                        if(quitarAcentos(cie.nombreCompleto.toUpperCase()).includes(quitarAcentos(cedula.toUpperCase()))){
                            busqueda.push(cie)
                        }
                    }
                )
                if(busqueda.length > 0){
                    if(isMostrarBusquedaMedico){
                    }
                    else{
                    }
                }
                else{
                    setIsMostrarBusqueda(true)
                }

                setResultMedicoList(busqueda)
            }
            else{
                setResultMedicoList([])
                setIsMostrarBusqueda(true)
            }
        }
        else{
            setResultMedicoList([])
            setIsMostrarBusquedaMedico(true)
            setSeMuestraMedico(false)
        }

    },[cedula,medicoList,isMostrarBusquedaMedico])
    
    useEffect(()=>{
        let busqueda = []
        if(nombreAnestesiologo){
            setSeMuestraMedicoAnestesiologo(true)

            if(nombreAnestesiologo.length >= 3){
                medicoList.forEach(
                    cie => {
                        if(quitarAcentos(cie.nombreCompleto.toUpperCase()).includes(quitarAcentos(nombreAnestesiologo.toUpperCase()))){
                            busqueda.push(cie)
                        }
                    }
                )
                if(busqueda.length > 0){
                    if(isMostrarBusquedaMedico){
                    }
                    else{
                    }
                }
                else{
                    setIsMostrarBusqueda(true)
                }

                setResultAnestesiologoList(busqueda)
            }
            else{
                setResultAnestesiologoList([])
                setIsMostrarBusqueda(true)
            }
        }
        else{
            setResultAnestesiologoList([])
            setIsMostrarBusquedaMedico(true)
            setSeMuestraMedicoAnestesiologo(false)
        }

    },[nombreAnestesiologo,medicoList,isMostrarBusquedaMedico])

    // ── Navegación por pasos ──
    const [currentStep, setCurrentStep] = useState(1)
    const TOTAL_STEPS = 4

    // ── Borrador en sessionStorage ──
    const DRAFT_KEY = 'qx_draft'

    const [hasDraft, setHasDraft] = useState(() => {
        try { return !!sessionStorage.getItem(DRAFT_KEY) } catch { return false }
    })

    const STEPS = [
        { num: 1, label: "Cirugía",  desc: "Hospital, quirófano y horario"           },
        { num: 2, label: "Médico",   desc: "Médico tratante y anestesiología"         },
        { num: 3, label: "Paciente", desc: "Datos del paciente"                       },
        { num: 4, label: "Clínica",  desc: "Procedimiento, imagen y hemoderivados"    },
    ]

    // ── Funciones de borrador ──────────────────────────────────────

    /** Campos del formulario que se persisten en sessionStorage */
    const getDraftData = () => ({
        buildingSelected, resourcesSelected,
        fecha_seleccionada, horaInicialSelected, horaFinalSelected,
        cedula, telefono, tipoAnestesiologo, nombreAnestesiologo, isAnestesiologoExterno,
        nombrePaciente, fecha_nacimiento, edad, sexo,
        tipoCliente, opcionCliente, pacienteHospitalizado,
        diagnostico, diagnosticoSeleccionado,
        procedimiento, procedimientoSeleccionado, ladoProcedimiento,
        isRayosX, isArcoC, isNoRequiereImagen,
        hadEspecificaciones, equipoQuirirgico, proveedorMaterial, materialProveedorList,
        hadRentaEquipos, equipoEspecial, proveedorEquipoEspecial, equipoEspecialProveedorList,
        hadMaterialEquipoEspecial, materialEquipoEspecial,
        hadHemoderivados, hemoderivados,
        hadEstudios, isEstudiosTransoperatorios, isEstudiosPostoperatorios, isNoRequiereEstudios,
        hadExtras, extras,
        isCheckedFechaNoSeCuenta,
        currentStep,
        savedAt: new Date().toISOString(),
    })

    /** Guarda el borrador en sessionStorage */
    const saveDraft = () => {
        try {
            sessionStorage.setItem(DRAFT_KEY, JSON.stringify(getDraftData()))
        } catch (e) {
            // sessionStorage lleno o bloqueado — se ignora silenciosamente
        }
    }

    /** Restaura el borrador al estado del componente */
    const restoreDraft = () => {
        try {
            const raw = sessionStorage.getItem(DRAFT_KEY)
            if (!raw) return
            const d = JSON.parse(raw)
            if (d.buildingSelected)             setBuildingSelected(d.buildingSelected)
            if (d.resourcesSelected)            setResourcesSelected(d.resourcesSelected)
            if (d.fecha_seleccionada)           setFechaSeleccionada(d.fecha_seleccionada)
            if (d.horaInicialSelected)          setHoraInicialSelected(d.horaInicialSelected)
            if (d.horaFinalSelected)            setHoraFinalSelected(d.horaFinalSelected)
            if (d.duracionSeleccionada)         setDuracionSeleccionada(d.duracionSeleccionada)
            if (d.cedula)                       setCedula(d.cedula)
            if (d.telefono)                     setTelefono(d.telefono)
            if (d.tipoAnestesiologo)            setTipoAnestesiologo(d.tipoAnestesiologo)
            if (d.nombreAnestesiologo)          setNombreAnestesiologo(d.nombreAnestesiologo)
            if (d.isAnestesiologoExterno !== undefined) setIsAnestesiologoExterno(d.isAnestesiologoExterno)
            if (d.nombrePaciente)               setNombrePaciente(d.nombrePaciente)
            if (d.fecha_nacimiento)             setFechaNacimiento(d.fecha_nacimiento)
            if (d.edad)                         setEdad(d.edad)
            if (d.sexo)                         setSexo(d.sexo)
            if (d.tipoCliente)                  setTipoCliente(d.tipoCliente)
            if (d.opcionCliente)                setOpcionCliente(d.opcionCliente)
            if (d.pacienteHospitalizado !== undefined) setPacienteHospitalizado(d.pacienteHospitalizado)
            if (d.diagnostico)                  setDiagnostico(d.diagnostico)
            if (d.diagnosticoSeleccionado)      setDiagnosticoSeleccionado(d.diagnosticoSeleccionado)
            if (d.procedimiento)                setProcedimiento(d.procedimiento)
            if (d.procedimientoSeleccionado)    setProcedimientoSeleccionado(d.procedimientoSeleccionado)
            if (d.ladoProcedimiento)            setLadoProcedimiento(d.ladoProcedimiento)
            if (d.isRayosX !== undefined)       setIsRayosX(d.isRayosX)
            if (d.isArcoC !== undefined)        setIsArcoC(d.isArcoC)
            if (d.isNoRequiereImagen !== undefined) setIsNoRequiereImagen(d.isNoRequiereImagen)
            if (d.hadEspecificaciones !== undefined) setHadEspecificaciones(d.hadEspecificaciones)
            if (d.equipoQuirirgico)             setEquipoQuirurgico(d.equipoQuirirgico)
            if (d.proveedorMaterial)            setProveedorMaterial(d.proveedorMaterial)
            if (d.materialProveedorList?.length) setMaterialProveedorList(d.materialProveedorList)
            if (d.hadRentaEquipos !== undefined) setRentaEquipos(d.hadRentaEquipos)
            if (d.equipoEspecial)               setEquipoEspecial(d.equipoEspecial)
            if (d.proveedorEquipoEspecial)      setProveedorEquipoEspecial(d.proveedorEquipoEspecial)
            if (d.equipoEspecialProveedorList?.length) setEquipoEspecialProveedorList(d.equipoEspecialProveedorList)
            if (d.hadMaterialEquipoEspecial !== undefined) setHadMaterialEquipoEspecial(d.hadMaterialEquipoEspecial)
            if (d.materialEquipoEspecial)        setMaterialEquipoEspecial(d.materialEquipoEspecial)
            if (d.hadHemoderivados !== undefined) setHadHemoderivados(d.hadHemoderivados)
            if (d.hemoderivados)                setHemoderivados(d.hemoderivados)
            if (d.hadEstudios !== undefined)    setHadEstudios(d.hadEstudios)
            if (d.isEstudiosTransoperatorios !== undefined) setIsEstudiosTransoperatorios(d.isEstudiosTransoperatorios)
            if (d.isEstudiosPostoperatorios !== undefined)  setIsEstudiosPostoperatorios(d.isEstudiosPostoperatorios)
            if (d.isNoRequiereEstudios !== undefined)       setIsNoRequiereEstudios(d.isNoRequiereEstudios)
            if (d.hadExtras !== undefined)      setHadExtras(d.hadExtras)
            if (d.extras)                       setExtras(d.extras)
            if (d.isCheckedFechaNoSeCuenta !== undefined) setIsCheckedFechaNoSeCuenta(d.isCheckedFechaNoSeCuenta)
            if (d.currentStep)                  setCurrentStep(d.currentStep)
            setHasDraft(false)
        } catch (e) {
            // borrador corrupto — se descarta
            clearDraft()
        }
    }

    /** Elimina el borrador de sessionStorage */
    const clearDraft = () => {
        try { sessionStorage.removeItem(DRAFT_KEY) } catch { /* noop */ }
        setHasDraft(false)
    }

    // Guarda automáticamente cada vez que cambia cualquier campo del formulario
    // (incluye el paso actual — currentStep — así que también se guarda al
    // avanzar/retroceder entre pasos, no solo al escribir en un campo).
    // Antes este guardado se bloqueaba por completo si ya existía un borrador
    // de una sesión anterior (hasDraft nunca pasaba a false salvo al
    // restaurar/descartar) — se corrige guardando siempre, sin esa condición.
    useEffect(() => {
        saveDraft()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        buildingSelected, resourcesSelected, fecha_seleccionada,
        horaInicialSelected, horaFinalSelected, duracionSeleccionada,
        cedula, telefono, tipoAnestesiologo, nombreAnestesiologo, isAnestesiologoExterno,
        nombrePaciente, fecha_nacimiento, edad, sexo, tipoCliente, opcionCliente,
        pacienteHospitalizado, isCheckedFechaNoSeCuenta,
        diagnostico, diagnosticoSeleccionado,
        procedimiento, procedimientoSeleccionado, ladoProcedimiento,
        isRayosX, isArcoC, isNoRequiereImagen,
        hadEspecificaciones, equipoQuirirgico, proveedorMaterial, materialProveedorList,
        hadRentaEquipos, equipoEspecial, proveedorEquipoEspecial, equipoEspecialProveedorList,
        hadMaterialEquipoEspecial, materialEquipoEspecial,
        hadHemoderivados, hemoderivados,
        hadEstudios, isEstudiosTransoperatorios, isEstudiosPostoperatorios, isNoRequiereEstudios,
        hadExtras, extras, currentStep,
    ])

    const validateStep = (step) => {
        let ok = true
        setMessageError("")
        if (step === 1) {
            if (buildingSelected === "-- Seleccione la unidad hospitalaria --") { setBuildHadError(true); setMessageError("Selecciona la unidad hospitalaria."); ok = false }
            else if (resourcesSelected === "-- Seleccione el quirófano deseado --") { setResourceHadError(true); setMessageError("Selecciona el quirófano."); ok = false }
            else if (!fecha_seleccionada) { setMessageError("Selecciona la fecha de la cirugía."); ok = false }
            else if (horaInicialSelected === "-- Seleccione la hora inicial --") { setHoraInicialHadError(true); setMessageError("Selecciona la hora de inicio."); ok = false }
            else if (horaFinalSelected === "-- Seleccione la hora final --") { setHoraFinalHadError(true); setMessageError("Selecciona la hora final."); ok = false }
        }
        if (step === 2) {
            if (!cedula) { setCedulaHadError(true); setMessageError("Ingresa el nombre del médico tratante."); ok = false }
            else if (!/^\d{10}$/gm.test(telefono)) { setTelefonoHadError(true); setMessageError("Ingresa un teléfono de 10 dígitos."); ok = false }
            else if (!nombreAnestesiologo || !tipoAnestesiologo) { setNombreAnestesiologoHadError(true); setMessageError("Selecciona el tipo de anestesiólogo."); ok = false }
        }
        if (step === 3) {
            if (!validarNombre(nombrePaciente)) { setNombrePacienteHadError(true); setMessageError("Ingresa el nombre del paciente."); ok = false }
            else if (!edad || !edad.trim()) { setMessageError("Ingresa la edad del paciente."); ok = false }
            else if (!tipoCliente || !opcionCliente) { setTipoClienteHadError(true); setMessageError("Selecciona el tipo de cliente."); ok = false }
        }
        if (step === 4) {
            if (!procedimiento || !procedimientoSeleccionado) { setProcedimientoHadError(true); setMessageError("Selecciona el procedimiento quirúrgico."); ok = false }
        }
        return ok
    }

    const goNext = () => {
        if (validateStep(currentStep)) setCurrentStep(s => Math.min(s + 1, TOTAL_STEPS))
    }
    const goPrev = () => { setMessageError(""); setCurrentStep(s => Math.max(s - 1, 1)) }

    return (
        <>
            {/* Spinner global de carga */}
            <MacSpinner visible={spinnerVisible} message={spinnerMessage}/>

            <div id="seccionCabeceraLogin" className='seccionCabeceraLogin'>
                <Header/>
            </div>
            <div className='cuerpoPacientes'>
                <div className="reserve_form">

                    {/* ── Título ── */}
                    <div className="rq-header">
                        <img src={macLogo} alt="Hospitales MAC" className="rq-header-logo"/>
                        <p className="rq-title">Quirófanos Cirugía Programada</p>
                        <p className="rq-subtitle">Complete los datos para solicitar su reservación</p>
                    </div>

                    {/* ── Barra de progreso ── */}
                    {/* ── Banner de borrador guardado ── */}
                    {hasDraft && (
                        <div className="rq-draft-banner">
                            <span className="rq-draft-icon">📋</span>
                            <div className="rq-draft-text">
                                <strong>Tienes un borrador guardado</strong>
                                <span>Puedes continuar donde lo dejaste</span>
                            </div>
                            <div className="rq-draft-actions">
                                <button className="rq-draft-btn rq-draft-btn--restore" onClick={restoreDraft}>
                                    Restaurar
                                </button>
                                <button className="rq-draft-btn rq-draft-btn--discard" onClick={clearDraft}>
                                    Descartar
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="rq-stepper">
                        {STEPS.map(s => (
                            <div key={s.num} className={`rq-step ${currentStep === s.num ? "rq-step--active" : ""} ${currentStep > s.num ? "rq-step--done" : ""}`}>
                                <div className="rq-step__bubble">
                                    {currentStep > s.num ? <span className="rq-step__check">✓</span> : s.num}
                                </div>
                                <span className="rq-step__label">{s.label}</span>
                            </div>
                        ))}
                    </div>

                    {/* ── Encabezado del paso actual ── */}
                    <div className="rq-step-header">
                        <div className="rq-step-header__num">Paso {currentStep} de {TOTAL_STEPS}</div>
                        <div className="rq-step-header__title">{STEPS[currentStep-1].label}</div>
                        <div className="rq-step-header__desc">{STEPS[currentStep-1].desc}</div>
                    </div>

                    {/* ══════════════════════════════════════
                        PASO 1 — DATOS DE LA CIRUGÍA
                    ══════════════════════════════════════ */}
                    {currentStep === 1 && (
                        <StepCirugia
                            buildHadError={buildHadError}
                            buildingList={buildingList}
                            buildingSelected={buildingSelected}
                            setBuildingSelected={setBuildingSelected}
                            clicBuildingSelect={clicBuildingSelect}
                            mostrarOcultarBuilding={() => toggleDropdown(setClicBuildingSelect)}
                            resourceHadError={resourceHadError}
                            resourcesList={resourcesList}
                            resourcesSelected={resourcesSelected}
                            setResourcesSelected={setResourcesSelected}
                            clicResourcesSelect={clicResourcesSelect}
                            mostrarOcultarResources={() => toggleDropdown(setResourcesClicSelect)}
                            fechaSeleccionadaHadError={fechaSeleccionadaHadError}
                            fecha_seleccionada={fecha_seleccionada}
                            today={today}
                            mostrarMensajeFecha={mostrarMensajeFecha}
                            onChangeDate={onChangeDate}
                            horaInicialHadError={horaInicialHadError}
                            horaInicialSelected={horaInicialSelected}
                            clicHoraInicialSelected={clicHoraInicialSelected}
                            mostrarOcultarHoraInicial={() => toggleDropdown(setClicHoraInicialSelected)}
                            horasInicialesDisponibles={horasInicialesDisponibles}
                            seleccionarHoraInicial={seleccionarHoraInicial}
                            horaFinalHadError={horaFinalHadError}
                            horaFinalSelected={horaFinalSelected}
                            duracionSeleccionada={duracionSeleccionada}
                            setDuracionSeleccionada={setDuracionSeleccionada}
                        />
                    )}

                    {/* ══════════════════════════════════════
                        PASO 2 — EQUIPO MÉDICO
                    ══════════════════════════════════════ */}
                    {currentStep === 2 && (
                        <StepMedico
                            cedulaHadError={cedulaHadError}
                            cedula={cedula}
                            onChangeCedula={onChangeCedula}
                            onFocusDiagnostico={onFocusDiagnostico}
                            onBlurDiagnostico={onBlurDiagnostico}
                            seMuestraMedico={seMuestraMedico}
                            handleCancelarMedicoClick={handleCancelarMedicoClick}
                            handleAgregarMedicoClick={handleAgregarMedicoClick}
                            resultMedicoList={resultMedicoList}
                            handleCedulaChange={handleCedulaChange}
                            MAX={MAX}
                            telefonoHadError={telefonoHadError}
                            telefono={telefono}
                            onChangeTelefono={onChangeTelefono}
                            nombreAnestesiologoHadError={nombreAnestesiologoHadError}
                            onChangeTipoAnestesiologo={onChangeTipoAnestesiologo}
                            isAnestesiologoExterno={isAnestesiologoExterno}
                            nombreAnestesiologo={nombreAnestesiologo}
                            onChangeNombreAnestesiologo={onChangeNombreAnestesiologo}
                            seMuestraMedicoAnestesiologo={seMuestraMedicoAnestesiologo}
                            handleCancelarMedicoAnestesiologoClick={handleCancelarMedicoAnestesiologoClick}
                            handleAgregarAnestesiologoClick={handleAgregarAnestesiologoClick}
                            resultAnestesiologoList={resultAnestesiologoList}
                            handleAnestesiologoChange={handleAnestesiologoChange}
                        />
                    )}

                    {/* ══════════════════════════════════════
                        PASO 3 — PACIENTE
                    ══════════════════════════════════════ */}
                    {currentStep === 3 && (
                        <StepPaciente
                            nombrePaciennteHadError={nombrePaciennteHadError}
                            nombrePaciente={nombrePaciente}
                            onChangeNombrePaciente={onChangeNombrePaciente}
                            MAX={MAX}
                            fechaNacimientoHadError={fechaNacimientoHadError}
                            fecha_nacimiento={fecha_nacimiento}
                            today={today}
                            onChangeNacimientoDate={onChangeNacimientoDate}
                            isCheckedFechaNoSeCuenta={isCheckedFechaNoSeCuenta}
                            handleCheckboxChangeFechaNacimiento={handleCheckboxChangeFechaNacimiento}
                            edad={edad}
                            onChangeEdad={onChangeEdad}
                            onChangeSexo={onChangeSexo}
                            tipoClienteHadError={tipoClienteHadError}
                            tipoCliente={tipoCliente}
                            onChangeTipoCliente={onChangeTipoCliente}
                            onFocusTipoCliente={onFocusTipoCliente}
                            onBlurTipoCliente={onBlurTipoCliente}
                            onChangeTypeCliente={onChangeTypeCliente}
                            pacienteHospitalizado={pacienteHospitalizado}
                            onCheckPacienteHospitalizado={onCheckPacienteHospitalizado}
                        />
                    )}

                    {/* ══════════════════════════════════════
                        PASO 4 — INFORMACIÓN CLÍNICA
                    ══════════════════════════════════════ */}
                    {currentStep === 4 && (
                        <StepClinica
                            diagnostico={diagnostico}
                            diagnosticoSeleccionado={diagnosticoSeleccionado}
                            onChangeDiagnostico={onChangeDiagnostico}
                            onFocusDiagnostico={onFocusDiagnostico}
                            onBlurDiagnostico={onBlurDiagnostico}
                            seMuestra={seMuestra}
                            handleCancelarClick={handleCancelarClick}
                            resultList={resultList}
                            handleDiagnosticoChange={handleDiagnosticoChange}
                            MAX={MAX}
                            procedimientoHadError={procedimientoHadError}
                            procedimiento={procedimiento}
                            procedimientoSeleccionado={procedimientoSeleccionado}
                            onChangeProcedimiento={onChangeProcedimiento}
                            onFocusProcedimiento={onFocusProcedimiento}
                            onBlurProcedimiento={onBlurProcedimiento}
                            seMuestraProdecimiento={seMuestraProdecimiento}
                            handleCancelarProcedimientoClick={handleCancelarProcedimientoClick}
                            resultProcedimientoList={resultProcedimientoList}
                            handleProcedimientoChange={handleProcedimientoChange}
                            isRayosX={isRayosX} onCheckRayosX={onCheckRayosX}
                            isArcoC={isArcoC} onCheckArcoC={onCheckArcoC}
                            isNoRequiereImagen={isNoRequiereImagen} onCheckNorequiereImagen={onCheckNorequiereImagen}
                            hemoderivadosHadError={hemoderivadosHadError}
                            hadHemoderivados={hadHemoderivados} onCheckHemoderivados={onCheckHemoderivados}
                            hemoderivados={hemoderivados} onChangeHemoderivados={onChangeHemoderivados}
                            hadMaterialEquipoEspecial={hadMaterialEquipoEspecial} onCheckMaterialEquipoEspecial={onCheckMaterialEquipoEspecial}
                            materialEquipoEspecial={materialEquipoEspecial} onChangeMaterialEquipoEspecial={onChangeMaterialEquipoEspecial}
                        />
                    )}

                    {/* ── Error general ── */}
                    {messageError && <p className="rq-error-msg">{messageError}</p>}

                    {/* ── Navegación entre pasos ── */}
                    <div className="rq-nav">
                        {currentStep > 1
                            ? <button className="rq-btn rq-btn--secondary" onClick={goPrev}>← Anterior</button>
                            : <div/>
                        }
                        {currentStep < TOTAL_STEPS
                            ? <button className="rq-btn rq-btn--primary" onClick={goNext}>Siguiente →</button>
                            : <button
                                className="rq-btn rq-btn--submit"
                                onClick={handleReservaClick()}
                                disabled={isSubmitting}
                                style={isSubmitting ? {opacity:.6, cursor:'not-allowed'} : {}}
                              >
                                {isSubmitting ? 'Enviando...' : 'Reservar quirófano'}
                              </button>
                        }
                    </div>

                    {/* Indicador de paso móvil */}
                    <p className="rq-step-dots">
                        {STEPS.map(s => (
                            <span key={s.num} className={`rq-dot ${currentStep === s.num ? "rq-dot--active" : currentStep > s.num ? "rq-dot--done" : ""}`}/>
                        ))}
                    </p>

                </div>
                <Footer />
            </div>
        </>
    )
}

export default ReservarCirugia;